import { jsxs, jsx } from 'react/jsx-runtime';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$9 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$8 = fails$9;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$7 = fails$9;

var functionBindNative = !fails$7(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$5 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$5.bind(call$5) : function () {
  return call$5.apply(call$5, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var bind = FunctionPrototype$1.bind;
var call$4 = FunctionPrototype$1.call;
var uncurryThis$a = NATIVE_BIND && bind.bind(call$4, call$4);

var functionUncurryThis = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis$a(fn);
} : function (fn) {
  return fn && function () {
    return call$4.apply(fn, arguments);
  };
};

var uncurryThis$9 = functionUncurryThis;

var toString$1 = uncurryThis$9({}.toString);
var stringSlice = uncurryThis$9(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var uncurryThis$8 = functionUncurryThis;
var fails$6 = fails$9;
var classof = classofRaw;

var $Object$2 = Object;
var split = uncurryThis$8(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$2('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object$2(it);
} : $Object$2;

var $TypeError$5 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw $TypeError$5("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$a = function (argument) {
  return typeof argument == 'function';
};

var isCallable$9 = isCallable$a;

var isObject$5 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$9(it);
};

var global$9 = global$a;
var isCallable$8 = isCallable$a;

var aFunction = function (argument) {
  return isCallable$8(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};

var uncurryThis$7 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$7({}.isPrototypeOf);

var getBuiltIn$2 = getBuiltIn$3;

var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

var global$8 = global$a;
var userAgent = engineUserAgent;

var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$5 = fails$9;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$5(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$1 = getBuiltIn$3;
var isCallable$7 = isCallable$a;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$1 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$7($Symbol) && isPrototypeOf($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$6 = isCallable$a;
var tryToString = tryToString$1;

var $TypeError$4 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$6(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var call$3 = functionCall;
var isCallable$5 = isCallable$a;
var isObject$4 = isObject$5;

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
  if (isCallable$5(fn = input.valueOf) && !isObject$4(val = call$3(fn, input))) return val;
  if (pref !== 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$7 = global$a;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$2(global$7, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$7[key] = value;
  } return value;
};

var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.0',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

var uncurryThis$6 = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$6({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$5 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString = uncurryThis$5(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$1 = function (name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$2 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol = wellKnownSymbol$1;

var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$2(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$4 = global$a;
var isObject$2 = isObject$5;

var document = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document) && isObject$2(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$4 = fails$9;
var createElement = documentCreateElement;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var call$1 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call$1(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$5 = descriptors;
var fails$3 = fails$9;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String = String;
var $TypeError$1 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$1($String(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$4 = functionUncurryThis;
var isCallable$4 = isCallable$a;
var store$1 = sharedStore;

var functionToString = uncurryThis$4(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$4(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$3 = global$a;
var isCallable$3 = isCallable$a;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$3.WeakMap;

var nativeWeakMap = isCallable$3(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$2 = global$a;
var uncurryThis$3 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$3(store.get);
  var wmhas = uncurryThis$3(store.has);
  var wmset = uncurryThis$3(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$3(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$1(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$3(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$2 = fails$9;
var isCallable$2 = isCallable$a;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function () {
  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS$1) defineProperty$1(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
    defineProperty$1(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$2(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

var isCallable$1 = isCallable$a;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$1 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$1(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$2 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var push = uncurryThis$2([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$1, key) && hasOwn$1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$3;
var uncurryThis$1 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

var concat$1 = uncurryThis$1([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$1 = fails$9;
var isCallable = isCallable$a;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var uncurryThis = functionUncurryThis;
var call = functionCall;
var fails = fails$9;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const Activity = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9 2a1 1 0 0 1 .949.684L15 17.838l2.051-6.154A1 1 0 0 1 18 11h4a1 1 0 1 1 0 2h-3.28l-2.771 8.316a1 1 0 0 1-1.898 0L9 6.162l-2.051 6.154A1 1 0 0 1 6 13H2a1 1 0 1 1 0-2h3.28l2.77-8.316A1 1 0 0 1 9 2Z",
      clipRule: "evenodd"
    })]
  }));
};

const Airplay = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3.293 4.293A1 1 0 0 1 4 4h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 1 0 0 2h1a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h1a1 1 0 1 0 0-2H4a1 1 0 0 1-1-1V5a1 1 0 0 1 .293-.707Zm9.475 10.067a1 1 0 0 0-1.536 0l-5 6A1 1 0 0 0 7 22h10a1 1 0 0 0 .768-1.64l-5-6ZM12 16.562 14.865 20h-5.73L12 16.562Z"
    })]
  }));
};

const AirplayAudio = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 11a9 9 0 0 1 18 0 8.959 8.959 0 0 1-2.07 5.744 1 1 0 0 0 1.538 1.277A10.959 10.959 0 0 0 23 11c0-6.075-4.925-11-11-11S1 4.925 1 11c0 2.65.939 5.084 2.5 6.983a1 1 0 1 0 1.545-1.27A8.959 8.959 0 0 1 3 11Zm9-5a5 5 0 0 0-4.104 7.857A1 1 0 0 1 6.256 15a7 7 0 1 1 11.49 0 1 1 0 0 1-1.642-1.145A5 5 0 0 0 12 6Zm-1 5a1 1 0 1 1 1.943.333A1 1 0 1 0 14.83 12a3 3 0 1 0-5.658 0 1 1 0 1 0 1.886-.667A.997.997 0 0 1 11 11Zm1.768 3.36a1 1 0 0 0-1.536 0l-5 6A1 1 0 0 0 7 22h10a1 1 0 0 0 .768-1.64l-5-6ZM12 16.562 14.865 20h-5.73L12 16.562Z"
    })]
  }));
};

const AlertCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm2-8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V8ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
    })]
  }));
};

const AlertOctagon = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm2-8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V8ZM7.153 1.293A1 1 0 0 1 7.86 1h8.28a1 1 0 0 1 .707.293l5.86 5.86A1 1 0 0 1 23 7.86v8.28a1 1 0 0 1-.293.707l-5.86 5.86a1 1 0 0 1-.707.293H7.86a1 1 0 0 1-.707-.293l-5.86-5.86A1 1 0 0 1 1 16.14V7.86a1 1 0 0 1 .293-.707l5.86-5.86ZM8.274 3 3 8.274v7.452L8.274 21h7.452L21 15.726V8.274L15.726 3H8.274Z"
    })]
  }));
};

const AlertTriangle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm0 8a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12ZM10.528 2.283a3 3 0 0 1 4.037 1.058l.003.005 8.47 14.14.008.014a2.999 2.999 0 0 1-2.565 4.5H3.519a3.001 3.001 0 0 1-2.565-4.5l.008-.014 8.47-14.14.003-.005a3 3 0 0 1 1.093-1.058Zm.618 2.094L2.683 18.506A1 1 0 0 0 3.536 20h16.928a1 1 0 0 0 .853-1.494L12.855 4.379l-.001-.002a1 1 0 0 0-1.708 0Z"
    })]
  }));
};

const AlignCenter = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm3 4a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H6Zm-4 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm4 3a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H6Z"
    })]
  }));
};

const AlignJustify = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm-1 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Zm0 4a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
    })]
  }));
};

const AlignLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm-1 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Zm0 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H3Z"
    })]
  }));
};

const AlignRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm3 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm-3 3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Zm4 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H7Z"
    })]
  }));
};

const Anchor = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13 8.874A4.002 4.002 0 0 0 12 1a4 4 0 0 0-1 7.874v12.07A9 9 0 0 1 3.056 13H5a1 1 0 1 0 0-2H2a1 1 0 0 0-1 1 11 11 0 1 0 22 0 1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2h1.944A9 9 0 0 1 13 20.944V8.874ZM10 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Aperture = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.836 22.94c.383.04.77.06 1.164.06 3.596 0 6.79-1.726 8.797-4.395a.996.996 0 0 0 .108-.146A10.95 10.95 0 0 0 23 12a10.964 10.964 0 0 0-.94-4.458A11.01 11.01 0 0 0 12 1C8.404 1 5.21 2.726 3.203 5.395a.994.994 0 0 0-.107.145A10.95 10.95 0 0 0 1 12a10.964 10.964 0 0 0 .94 4.457 11.01 11.01 0 0 0 8.896 6.482ZM11.422 7l2.223-3.85A9.005 9.005 0 0 1 19.485 7h-8.063ZM7.38 10l1.435-2.485.017-.028 2.58-4.468a8.98 8.98 0 0 0-6.254 3.133L7.38 10Zm-.852 2.524L7.958 15H3.512A8.985 8.985 0 0 1 3 12c0-1.43.333-2.781.926-3.981l2.575 4.459.027.046ZM12.578 17H4.516a9.005 9.005 0 0 0 5.839 3.85L12.578 17Zm1.155-2h-3.466l-1.732-3 1.732-3h3.466l1.732 3-1.732 3Zm1.436 1.512a.927.927 0 0 0 .015-.025L16.62 14l2.222 3.847a8.98 8.98 0 0 1-6.253 3.134l2.58-4.469Zm2.33-4.99 2.575 4.46A8.976 8.976 0 0 0 21 12c0-1.052-.18-2.062-.512-3h-4.446l1.43 2.476c.01.015.018.03.027.046Z",
      clipRule: "evenodd"
    })]
  }));
};

const Archive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M10 13h4c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1ZM23 2H1c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h1v12c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V9h1c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Zm-3 18H4V9h16v11Zm2-13H2V4h20v3Z"
    })]
  }));
};

const ArrowDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13 5a1 1 0 1 0-2 0v11.586l-5.293-5.293a1 1 0 0 0-1.414 1.414l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0-1.414-1.414L13 16.586V5Z"
    })]
  }));
};

const ArrowDownCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7.293 11.293a1 1 0 0 1 1.414 0L11 13.586V8a1 1 0 1 1 2 0v5.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
    })]
  }));
};

const ArrowDownLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "m9.414 16 8.293-8.293a1 1 0 0 0-1.414-1.414L8 14.586V7a1 1 0 0 0-2 0v10a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H9.414Z"
    })]
  }));
};

const ArrowDownRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7.707 6.293a1 1 0 0 0-1.414 1.414L14.586 16H7a1 1 0 1 0 0 2h10.003a.996.996 0 0 0 .71-.3.997.997 0 0 0 .287-.697V7a1 1 0 1 0-2 0v7.586L7.707 6.293Z"
    })]
  }));
};

const ArrowLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.707 5.707a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L7.414 13h11.711c.483 0 .875-.448.875-1s-.392-1-.875-1H7.415l5.292-5.293Z"
    })]
  }));
};

const ArrowLeftCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.707 7.293a1 1 0 0 1 0 1.414L10.414 11H16.2c.442 0 .8.448.8 1s-.358 1-.8 1h-5.786l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
    })]
  }));
};

const ArrowRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.707 4.293a1 1 0 1 0-1.414 1.414L16.586 11H4.875C4.392 11 4 11.448 4 12s.392 1 .875 1h11.71l-5.292 5.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7Z"
    })]
  }));
};

const ArrowRightCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "m12.707 7.293 4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13H7.8c-.442 0-.8-.448-.8-1s.358-1 .8-1h5.786l-2.293-2.293a1 1 0 0 1 1.414-1.414ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
    })]
  }));
};

const ArrowUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.707 4.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 1 0 1.414 1.414L11 7.414v11.648c0 .518.448.938 1 .938s1-.42 1-.938V7.415l5.293 5.293a1 1 0 0 0 1.414-1.414l-7-7Z"
    })]
  }));
};

const ArrowUpCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "m12.707 7.293 4 4a1 1 0 0 1-1.414 1.414L13 10.414V16.2c0 .442-.448.8-1 .8s-1-.358-1-.8v-5.786l-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
    })]
  }));
};

const ArrowUpLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V9.414l8.293 8.293a1 1 0 1 0 1.414-1.414L9.414 8H17a1 1 0 1 0 0-2H7Z"
    })]
  }));
};

const ArrowUpRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7 6a1 1 0 0 0 0 2h7.586l-8.293 8.293a1 1 0 1 0 1.414 1.414L16 9.414V17a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1H7Z"
    })]
  }));
};

const AtSign = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M14.5 1.289a11 11 0 1 0 4.188 19.445 1 1 0 0 0-1.216-1.588A9 9 0 1 1 21 12v1a2 2 0 1 1-4 0V8a1 1 0 0 0-2 0 5 5 0 1 0 .74 7.319A4.006 4.006 0 0 0 19 17a4 4 0 0 0 4-4v-1a11 11 0 0 0-8.5-10.711ZM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Audio = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3 11.5a9 9 0 0 1 18 0v7c0 1.66-1.34 3-3 3h-3v-8h4v-2c0-3.87-3.13-7-7-7s-7 3.13-7 7v2h4v8H6c-1.66 0-3-1.34-3-3v-7Zm4 4v4H6c-.55 0-1-.45-1-1v-3h2Zm12 0v3c0 .55-.45 1-1 1h-1v-4h2Z",
      clipRule: "evenodd"
    })]
  }));
};

const Award = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.14 14.355a8 8 0 1 1 9.722 0l1.13 8.514a1 1 0 0 1-1.507.989L12 21.166l-4.485 2.692a1 1 0 0 1-1.506-.99l1.13-8.513ZM6 8a6 6 0 1 1 9.33 4.992c-.056.029-.11.064-.16.103A6 6 0 0 1 6 8Zm8.986 7.424A7.979 7.979 0 0 1 12 16a7.977 7.977 0 0 1-2.985-.575l-.75 5.65 3.22-1.933a1 1 0 0 1 1.03 0l3.22 1.933-.749-5.65Z",
      clipRule: "evenodd"
    })]
  }));
};

const BarChart = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19 4a1 1 0 1 0-2 0v16a1 1 0 1 0 2 0V4Zm-7 5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Zm-6 6a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z"
    })]
  }));
};

const BarChart2 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 13a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm12-4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Zm-6-6a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Battery = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H3ZM2 8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8Zm22 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
      clipRule: "evenodd"
    })]
  }));
};

const BatteryCharging = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.19a1 1 0 0 1 0 2H3Zm11-1a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.19a1 1 0 1 1 0-2H17a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2a1 1 0 0 1-1-1Zm9 4a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1ZM11.832 6.555a1 1 0 0 0-1.664-1.11l-4 6A1 1 0 0 0 7 13h4.132l-2.964 4.445a1 1 0 0 0 1.664 1.11l4-6A1 1 0 0 0 13 11H8.869l2.963-4.445Z"
    })]
  }));
};

const Bluetooth = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.617.076a1 1 0 0 1 1.09.217l5.5 5.5a1 1 0 0 1 0 1.414L13.414 12l4.793 4.793a1 1 0 0 1 0 1.414l-5.5 5.5A1 1 0 0 1 11 23v-8.586l-3.793 3.793a1 1 0 1 1-1.414-1.414L10.586 12 5.793 7.207a1 1 0 0 1 1.414-1.414L11 9.586V1a1 1 0 0 1 .617-.924ZM13 14.414l3.086 3.086L13 20.586v-6.172Zm0-4.828V3.414L16.086 6.5 13 9.586Z",
      clipRule: "evenodd"
    })]
  }));
};

const Bold = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h9a5 5 0 0 0 2.435-9.367A5 5 0 0 0 14 3H6Zm8 8a3 3 0 0 0 0-6H7v6h7Zm-7 2v6h8a3 3 0 0 0 0-6H7Z",
      clipRule: "evenodd"
    })]
  }));
};

const Book = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M21 2a1 1 0 0 0-1-1H6.5A3.5 3.5 0 0 0 3 4.5v15A3.5 3.5 0 0 0 6.5 23H20a1 1 0 0 0 1-1V2ZM5.44 3.44A1.5 1.5 0 0 1 6.5 3H19v13H6.5a3.5 3.5 0 0 0-1.5.338V4.5c0-.398.158-.78.44-1.06ZM5 19.5A1.5 1.5 0 0 0 6.5 21H19v-3H6.5A1.5 1.5 0 0 0 5 19.5Z",
      clipRule: "evenodd"
    })]
  }));
};

const Bookmark = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7 4a1 1 0 0 0-1 1v14.057l5.419-3.87a1 1 0 0 1 1.162 0L18 19.056V5a1 1 0 0 0-1-1H7ZM4.879 2.879A3 3 0 0 1 7 2h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.581.814L12 17.229l-6.419 4.585A1 1 0 0 1 4 21V5a3 3 0 0 1 .879-2.121Z",
      clipRule: "evenodd"
    })]
  }));
};

const BookmarkActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4.879 2.879A3 3 0 0 1 7 2h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.581.814L12 17.229l-6.419 4.585A1 1 0 0 1 4 21V5a3 3 0 0 1 .879-2.121Z"
    })]
  }));
};

const BookOpen = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2 2a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h7a2 2 0 0 1 2 2 1 1 0 1 0 2 0 2 2 0 0 1 2-2h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-6a5 5 0 0 0-4 2 5 5 0 0 0-4-2H2Zm11 15.536A4 4 0 0 1 15 17h6V4h-5a3 3 0 0 0-3 3v10.536Zm-2 0V7a3 3 0 0 0-3-3H3v13h6a4 4 0 0 1 2 .536Z",
      clipRule: "evenodd"
    })]
  }));
};

const Box = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.502 1.403a3 3 0 0 1 2.996 0h.002l7 4a3 3 0 0 1 .937.85 1.004 1.004 0 0 1 .249.413A3 3 0 0 1 22 7.999V16a3 3 0 0 1-1.5 2.595l-.004.002-6.996 3.998-.002.001a3 3 0 0 1-1.022.363.995.995 0 0 1-.952 0 3 3 0 0 1-1.022-.363l-.002-.001-6.996-3.998-.004-.002A3 3 0 0 1 2 16V7.999a3 3 0 0 1 .314-1.333 1.003 1.003 0 0 1 .25-.414 3 3 0 0 1 .936-.848l.004-.002 6.998-4ZM13 20.578l6.5-3.714.002-.001a1.001 1.001 0 0 0 .498-.864V8.537l-7 4.05v7.991Zm-2-7.991v7.991l-6.5-3.714-.002-.001A1 1 0 0 1 4 15.999V8.537l7 4.05Zm1.5-9.451 6.461 3.692L12 10.855 5.039 6.828l6.457-3.69.004-.002a1 1 0 0 1 1 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Briefcase = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10 2a3 3 0 0 0-3 3v1H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-3V5a3 3 0 0 0-3-3h-4Zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1h6ZM9 8h6v12H9V8ZM7 8H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3V8Zm10 12V8h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3Z",
      clipRule: "evenodd"
    })]
  }));
};

const Calendar = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16 1a1 1 0 0 1 1 1v1h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1ZM4 17v3a1 1 0 0 0 1 1h3v-4H4Zm4-2H4v-4h4v4Zm2 2v4h4v-4h-4Zm4-2h-4v-4h4v4Zm2 2v4h3a1 1 0 0 0 1-1v-3h-4Zm4-2h-4v-4h4v4Zm0-9v3H4V6a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0V5h2a1 1 0 0 1 1 1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Camera = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 8a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM9 2a1 1 0 0 0-.832.445L6.465 5H3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-3.465l-1.703-2.555A1 1 0 0 0 15 2H9ZM7.832 6.555 9.535 4h4.93l1.703 2.555A1 1 0 0 0 17 7h4a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4a1 1 0 0 0 .832-.445Z",
      clipRule: "evenodd"
    })]
  }));
};

const CameraOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 26 25",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M24.71 23.29a.996.996 0 1 1-1.41 1.41l-1.71-1.71H4c-.8 0-1.56-.32-2.12-.88S1 20.78 1 19.99V9c0-.8.32-1.56.88-2.12S3.21 6 4 6h.59l-3.3-3.29c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l8.7 8.71.03.03 5.53 5.53.03.03 5.71 5.71 2 2v-.01Zm-.59-16.41C23.56 6.32 22.79 6 22 6h-3.46l-1.7-2.55c-.19-.28-.5-.45-.83-.45h-6c-.55 0-1 .45-1 1s.45 1 1 1h5.46l1.7 2.55c.19.28.5.45.83.45h4c.27 0 .52.11.71.29.19.19.29.44.29.71v9.34c0 .55.45 1 1 1s1-.45 1-1V9c0-.8-.32-1.56-.88-2.12Zm-13.26 9.26a3.016 3.016 0 0 0 2.4.87 3.018 3.018 0 0 0 1.65-.69l-4.23-4.23a3.019 3.019 0 0 0-.69 1.65c-.04.44.02.88.17 1.3.15.41.39.79.7 1.1Zm5.47 1.6A5.05 5.05 0 0 1 13.45 19a5.027 5.027 0 0 1-5.17-3.29c-.25-.69-.34-1.43-.28-2.16a5.05 5.05 0 0 1 1.26-2.88L6.58 7.99H4c-.27 0-.52.11-.71.29a.99.99 0 0 0-.29.71v11c0 .27.11.52.29.71.19.19.44.29.71.29h15.59l-3.26-3.26v.01Z"
    })]
  }));
};

const Cast = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3.293 5.293A1 1 0 0 1 4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-6a1 1 0 1 0 0 2h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v2a1 1 0 1 0 2 0V6a1 1 0 0 1 .293-.707ZM2.11 11.056a1 1 0 0 0-.22 1.988 8 8 0 0 1 7.066 7.066 1 1 0 0 0 1.988-.22 10 10 0 0 0-8.834-8.834Zm.09 4.064a1 1 0 1 0-.4 1.96 4 4 0 0 1 3.12 3.12 1 1 0 1 0 1.96-.4 6 6 0 0 0-4.68-4.68ZM2 19a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H2Z"
    })]
  }));
};

const CastConnected = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4 5a1 1 0 0 0-1 1v2a1 1 0 0 1-2 0V6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-6a1 1 0 1 1 0-2h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Zm-2.994 6.94a1 1 0 0 1 1.104-.884 10 10 0 0 1 8.834 8.834 1 1 0 0 1-1.988.22 8 8 0 0 0-7.067-7.066 1 1 0 0 1-.883-1.104Zm.014 3.96a1 1 0 0 1 1.18-.78 6 6 0 0 1 4.68 4.68 1 1 0 1 1-1.96.4 4 4 0 0 0-3.12-3.12 1 1 0 0 1-.78-1.18ZM1 20a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1ZM5.5 7a.5.5 0 0 0-.5.5v1.156a.52.52 0 0 0 .318.475c.87.373 3.346 1.533 5.182 3.369 1.433 1.433 2.142 3.328 2.392 4.123a.53.53 0 0 0 .501.377H18.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13Z"
    })]
  }));
};

const Check = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20.707 5.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586 19.293 5.293a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const CheckCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M10.017 3.216a9 9 0 0 1 5.646.558 1 1 0 1 0 .814-1.827A11 11 0 1 0 23 12v-.92a1 1 0 1 0-2 0V12a9 9 0 1 1-10.983-8.784Zm12.69 1.49a1 1 0 0 0-1.415-1.413L12 12.595l-2.293-2.292a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.415 0l10-10.01Z"
    })]
  }));
};

const CheckSquare = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4.293 4.293A1 1 0 0 1 5 4h11a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 1 0-2 0v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 .293-.707Zm8.414 10.414 10-10a1 1 0 0 0-1.414-1.414L12 12.586l-2.293-2.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0Z"
    })]
  }));
};

const ChevronDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M5.293 9.293a1 1 0 0 1 1.414 0L12 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z"
    })]
  }));
};

const ChevronLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M14.707 5.293a1 1 0 0 1 0 1.414L9.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z"
    })]
  }));
};

const ChevronRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M9.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 12 9.293 6.707a1 1 0 0 1 0-1.414Z"
    })]
  }));
};

const ChevronsDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7.707 5.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L12 9.586 7.707 5.293Zm0 7a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L12 16.586l-4.293-4.293Z"
    })]
  }));
};

const ChevronsLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11.707 7.707a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L7.414 12l4.293-4.293Zm7 0a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L14.414 12l4.293-4.293Z"
    })]
  }));
};

const ChevronsRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M6.707 6.293a1 1 0 0 0-1.414 1.414L9.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Zm7 0a1 1 0 1 0-1.414 1.414L16.586 12l-4.293 4.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Z"
    })]
  }));
};

const ChevronsUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.707 5.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 1 0 1.414 1.414L12 7.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-5-5Zm5 12-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 1 0 1.414 1.414L12 14.414l4.293 4.293a1 1 0 0 0 1.414-1.414Z"
    })]
  }));
};

const ChevronUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11.293 8.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6Z"
    })]
  }));
};

const Circle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z",
      clipRule: "evenodd"
    })]
  }));
};

const Clipboard = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-1a2 2 0 0 0-2-2H9Zm8 4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1ZM9 5h6V3H9v2Z",
      clipRule: "evenodd"
    })]
  }));
};

const Clock = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7.29.386a1 1 0 0 1-.176 1.403l-4.5 3.5a1 1 0 0 1-1.228-1.578l4.5-3.5A1 1 0 0 1 7.29.386ZM13 7a1 1 0 1 0-2 0v5.25a1 1 0 0 0 .6.916l4 1.75a1 1 0 0 0 .8-1.832L13 11.596V7Zm-1-5C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0ZM16.886 1.79A1 1 0 0 1 18.114.21l4.5 3.5a1 1 0 0 1-1.228 1.58l-4.5-3.5Z"
    })]
  }));
};

const Close = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293Z"
    })]
  }));
};

const ClosedCaption = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1Zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1Z"
    })]
  }));
};

const Cloud = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 25 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M6.87 3.56A9 9 0 0 0 10 21h9a6 6 0 0 0 4.243-10.243l-.203-.193A6 6 0 0 0 19 9h-.522l-.075-.209A9 9 0 0 0 7.21 3.441l-.34.119Zm4.535 1.584a7 7 0 0 1 5.367 5.106 1 1 0 0 0 .968.75H19a4 4 0 1 1 0 8h-9a7.001 7.001 0 1 1 1.405-13.856Z"
    })]
  }));
};

const CloudDrizzle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 25 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13.263.615A9 9 0 0 0 4.376 16.03a1 1 0 0 0 1.248-1.562A7 7 0 1 1 16.772 7.25a1 1 0 0 0 .968.75H19a4 4 0 0 1 1.599 7.664 1 1 0 1 0 .802 1.832A6 6 0 0 0 19.001 6h-.522A8.999 8.999 0 0 0 13.263.615ZM18 13a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm-5 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm-3 5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm7-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm-4-8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z"
    })]
  }));
};

const CloudLightning = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 26 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.906.485a9 9 0 0 0-7.27 16.39 1 1 0 1 0 .968-1.75A7 7 0 1 1 16.772 7.25a1 1 0 0 0 .968.75H19l.228.006a4 4 0 0 1 .573 7.914 1 1 0 1 0 .398 1.96 6 6 0 0 0 2.828-10.333l-.211-.181A6 6 0 0 0 18.999 6h-.521l-.083-.23A8.999 8.999 0 0 0 12.906.486Zm1.649 9.683a1 1 0 0 0-1.387.277l-4 6-.057.097A1 1 0 0 0 10 18h4.13l-2.962 4.445-.06.101a1 1 0 0 0 1.724 1.009l4-6 .057-.096A1 1 0 0 0 16 16h-4.132l2.964-4.445.06-.101a1 1 0 0 0-.337-1.286Z"
    })]
  }));
};

const CloudRain = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 25 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13.263.615A9 9 0 0 0 4.376 16.03a1 1 0 0 0 1.248-1.562A7 7 0 1 1 16.772 7.25a1 1 0 0 0 .968.75H19a4 4 0 0 1 1.599 7.664 1 1 0 1 0 .802 1.832A6 6 0 0 0 19.001 6h-.522A8.999 8.999 0 0 0 13.263.615ZM10 13a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm8 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm-5 1a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1Z"
    })]
  }));
};

const CloudSnow = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 25 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13.263 1.615A9 9 0 0 0 4.376 17.03a1 1 0 0 0 1.248-1.562A7 7 0 1 1 16.772 8.25a1 1 0 0 0 .968.75H19a4 4 0 0 1 1.599 7.664 1 1 0 1 0 .802 1.832A6 6 0 0 0 19.001 7h-.522a8.999 8.999 0 0 0-5.216-5.385ZM12 18a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm-3 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H9Zm7 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Zm-4 2a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm4-6a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Zm-7-1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H9Z"
    })]
  }));
};

const Code = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M15.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L20.586 12l-5.293-5.293a1 1 0 0 1 0-1.414Zm-6.586 0a1 1 0 0 1 0 1.414L3.414 12l5.293 5.293a1 1 0 1 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Codepen = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.557 1.17a.995.995 0 0 0-1.114 0L1.469 7.651a.993.993 0 0 0-.358.39.994.994 0 0 0-.111.455v7.006a.995.995 0 0 0 .472.847l9.971 6.48a.995.995 0 0 0 1.114 0l9.967-6.478a.998.998 0 0 0 .476-.87V8.518a.995.995 0 0 0-.473-.868l-9.97-6.48ZM11 3.842 3.788 8.53 7 10.779l4-2.8V3.843Zm2 4.136V3.843l7.212 4.688L17 10.779l-4-2.8ZM18.744 12 21 10.42v3.16L18.744 12ZM12 9.72 8.744 12 12 14.28 15.256 12 12 9.72Zm-9 .7L5.256 12 3 13.58v-3.16Zm4 2.8-3.212 2.25L11 20.156V16.02l-4-2.8Zm13.212 2.25L17 13.22l-4 2.8v4.137l7.212-4.688Z",
      clipRule: "evenodd"
    })]
  }));
};

const Codesandbox = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1.002a3 3 0 0 0-1.498.4L7.306 3.23a1 1 0 0 0-.554.316L3.504 5.402l-.004.002a3 3 0 0 0-.937.848 1.001 1.001 0 0 0-.25.414A3 3 0 0 0 2 8v8a3 3 0 0 0 1.5 2.595l.004.002 3.249 1.857a.99.99 0 0 0 .554.316l3.193 1.825.002.001a3 3 0 0 0 1.022.363.995.995 0 0 0 .952 0 3 3 0 0 0 1.022-.363l.002-.001 3.193-1.825a.999.999 0 0 0 .554-.316l3.25-1.857.003-.002A3 3 0 0 0 22 16V7.999a3 3 0 0 0-.314-1.334 1 1 0 0 0-.249-.413 3 3 0 0 0-.937-.848l-3.253-1.859a1 1 0 0 0-.553-.316L13.5 1.404l-.002-.001A3 3 0 0 0 12 1.002Zm2.44 3.243-1.94-1.11a1 1 0 0 0-1 0l-.004.003L9.56 4.245 12 5.655l2.442-1.41ZM7.55 5.393 5.038 6.828l6.96 4.027 6.962-4.027-2.51-1.435-3.95 2.283a1 1 0 0 1-1.001 0L7.55 5.393ZM15.5 19.15 13 20.578v-7.991l7-4.05v2.886l-4 2.311a1 1 0 0 0-.5.866v4.55ZM11 20.578v-7.991l-7-4.05v2.886l4 2.311a1 1 0 0 1 .5.866v4.55l2.5 1.428ZM4 16v-2.266l2.5 1.444v2.83l-2-1.143-.002-.001A1 1 0 0 1 4 15.999Zm13.5 2.008 2-1.143.002-.001A1.001 1.001 0 0 0 20 16v-2.266l-2.5 1.444v2.83Z",
      clipRule: "evenodd"
    })]
  }));
};

const Coffee = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M14 0c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1ZM2 7c-.55 0-1 .45-1 1v9c0 1.33.52 2.6 1.46 3.54C3.4 21.47 4.67 22 6 22h8c1.33 0 2.6-.52 3.54-1.46C18.47 19.6 19 18.33 19 17c1.33 0 2.6-.52 3.54-1.46C23.47 14.6 24 13.33 24 12s-.52-2.6-1.46-3.54A5.036 5.036 0 0 0 19 7H2Zm17 2c.79 0 1.56.32 2.12.88S22 11.21 22 12s-.32 1.56-.88 2.12S19.8 15 19 15V9ZM3.88 19.12C3.32 18.56 3 17.8 3 17V9h14v8c0 .79-.32 1.56-.88 2.12S14.8 20 14 20H6c-.79 0-1.56-.32-2.12-.88ZM10 0c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1ZM6 0c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1Z"
    })]
  }));
};

const Columns = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2.879 2.879A3 3 0 0 1 5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 .879-2.121ZM13 20h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-6v16ZM11 4v16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Command = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3.172 3.172A4 4 0 0 1 10 6v2h4V6a4 4 0 1 1 4 4h-2v4h2a4 4 0 1 1-4 4v-2h-4v2a4 4 0 1 1-4-4h2v-4H6a4 4 0 0 1-2.828-6.828ZM8 8V6a2 2 0 1 0-2 2h2Zm2 2v4h4v-4h-4Zm-2 6H6a2 2 0 1 0 2 2v-2Zm8 0v2a2 2 0 1 0 2-2h-2Zm0-8h2a2 2 0 1 0-2-2v2Z",
      clipRule: "evenodd"
    })]
  }));
};

const Compass = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M17.189 8.076a1 1 0 0 0-1.265-1.265l-6.36 2.12a1 1 0 0 0-.633.633l-2.12 6.36a1 1 0 0 0 1.265 1.265l6.36-2.12a1 1 0 0 0 .633-.633l2.12-6.36ZM9.34 14.66l1.33-3.988 3.988-1.33-1.33 3.989L9.34 14.66ZM12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
    })]
  }));
};

const ConnectedDevices = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M14 20a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1Zm0-16a1 1 0 0 1 1-1h5.78C22.516 3 24 4.372 24 6.14v8.72c0 1.768-1.484 3.14-3.22 3.14H15a1 1 0 1 1 0-2h5.78c.704 0 1.22-.548 1.22-1.14V6.14C22 5.548 21.484 5 20.78 5H15a1 1 0 0 1-1-1ZM2.83 4a.81.81 0 0 0-.83.79v14.42c0 .402.337.79.83.79h7.33c.466 0 .83-.359.83-.79V4.79a.81.81 0 0 0-.83-.79H2.83ZM0 4.79A2.81 2.81 0 0 1 2.83 2h7.33a2.81 2.81 0 0 1 2.83 2.79v14.42c0 1.649-1.376 2.79-2.83 2.79H2.83A2.81 2.81 0 0 1 0 19.21V4.79ZM6.5 19a1.005 1.005 0 0 1-1-1.01c0-.28.11-.52.3-.7a1.002 1.002 0 0 1 1.7.7c0 .26-.11.52-.3.72a.99.99 0 0 1-.71.29h.01Z"
    })]
  }));
};

const Copy = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3.293 3.293A1 1 0 0 1 4 3h9a1 1 0 0 1 1 1v1a1 1 0 1 0 2 0V4a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h1a1 1 0 1 0 0-2H4a1 1 0 0 1-1-1V4a1 1 0 0 1 .293-.707ZM11 8a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3h-9Zm-1 3a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-9Z"
    })]
  }));
};

const CornerDownLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M22 4a1 1 0 1 0-2 0v7a3 3 0 0 1-3 3H6.414l3.293-3.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 16H17a5 5 0 0 0 5-5V4Z"
    })]
  }));
};

const CornerDownRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M5 4a1 1 0 0 0-2 0v7a5 5 0 0 0 5 5h9.586l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5a1 1 0 1 0-1.414 1.414L17.586 14H8a3 3 0 0 1-3-3V4Z"
    })]
  }));
};

const CornerLeftDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13 3a5 5 0 0 0-5 5v9.586l-3.293-3.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L10 17.586V8a3 3 0 0 1 3-3h7a1 1 0 1 0 0-2h-7Z"
    })]
  }));
};

const CornerLeftUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M9.707 3.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L8 6.414V16a5 5 0 0 0 5 5h7a1 1 0 1 0 0-2h-7a3 3 0 0 1-3-3V6.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-5-5Z"
    })]
  }));
};

const CornerRightDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4 3a1 1 0 0 0 0 2h7a3 3 0 0 1 3 3v9.586l-3.293-3.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L16 17.586V8a5 5 0 0 0-5-5H4Z"
    })]
  }));
};

const CornerRightUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15.707 3.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L14 6.414V16a3 3 0 0 1-3 3H4a1 1 0 1 0 0 2h7a5 5 0 0 0 5-5V6.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-5-5Z"
    })]
  }));
};

const CornerUpLeft = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M9.707 4.707a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 10H16a3 3 0 0 1 3 3v7a1 1 0 1 0 2 0v-7a5 5 0 0 0-5-5H6.414l3.293-3.293Z"
    })]
  }));
};

const CornerUpRight = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15.707 3.293a1 1 0 1 0-1.414 1.414L17.586 8H8a5 5 0 0 0-5 5v7a1 1 0 1 0 2 0v-7a3 3 0 0 1 3-3h9.586l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Z"
    })]
  }));
};

const Cpu = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M9 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9Zm1 6v-4h4v4h-4ZM9 0a1 1 0 0 1 1 1v2h4V1a1 1 0 1 1 2 0v2h2a3 3 0 0 1 3 3v2h2a1 1 0 1 1 0 2h-2v3h2a1 1 0 1 1 0 2h-2v3a3 3 0 0 1-3 3h-2v2a1 1 0 1 1-2 0v-2h-4v2a1 1 0 1 1-2 0v-2H6a3 3 0 0 1-3-3v-3H1a1 1 0 1 1 0-2h2v-3H1a1 1 0 1 1 0-2h2V6a3 3 0 0 1 3-3h2V1a1 1 0 0 1 1-1ZM5 18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12Z"
    })]
  }));
};

const CreditCard = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M0 6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6Zm2 0a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3H2V6Zm20 5v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7h20Z",
      clipRule: "evenodd"
    })]
  }));
};

const Crop = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.13 1.009a1 1 0 1 0-2-.018l-.036 4.103-4.103.036a1 1 0 1 0 .018 2l4.068-.035L5 15.99V16a3 3 0 0 0 3 3h9v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4V8a3 3 0 0 0-3-3l-8.905.077.035-4.068Zm-.053 6.068L7 16.004A1 1 0 0 0 8 17h9V8a1 1 0 0 0-.996-1l-8.927.077Z",
      clipRule: "evenodd"
    })]
  }));
};

const Crosshair = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-1 2.055A9.004 9.004 0 0 0 3.055 11H6a1 1 0 1 1 0 2H3.055A9.004 9.004 0 0 0 11 20.945V18a1 1 0 1 1 2 0v2.945A9.004 9.004 0 0 0 20.945 13H18a1 1 0 1 1 0-2h2.945A9.004 9.004 0 0 0 13 3.055V6a1 1 0 1 1-2 0V3.055Z",
      clipRule: "evenodd"
    })]
  }));
};

const Database = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M22 5c0-.852-.519-1.504-1.088-1.953-.581-.458-1.36-.826-2.232-1.117C16.925 1.345 14.563 1 12 1c-2.563 0-4.925.345-6.68.93-.873.29-1.651.66-2.232 1.117C2.518 3.496 2 4.148 2 5v14c0 .85.513 1.502 1.082 1.953.579.459 1.355.827 2.226 1.118C7.061 22.656 9.423 23 12 23s4.939-.344 6.692-.929c.87-.29 1.647-.66 2.226-1.118C21.487 20.502 22 19.849 22 19V5ZM4.003 4.985 4 5c0 .001 0 .006.003.015a.296.296 0 0 0 .032.066c.043.07.13.174.291.301.33.26.87.539 1.626.79C7.454 6.674 9.592 7 12 7s4.546-.327 6.048-.827c.756-.252 1.296-.53 1.626-.79.162-.128.248-.232.29-.302a.293.293 0 0 0 .033-.066A.052.052 0 0 0 20 5l-.003-.015a.293.293 0 0 0-.032-.066 1.235 1.235 0 0 0-.291-.301c-.33-.26-.87-.539-1.626-.79C16.546 3.326 14.408 3 12 3s-4.546.327-6.048.827c-.756.252-1.296.53-1.626.79a1.236 1.236 0 0 0-.29.302.296.296 0 0 0-.033.066ZM20 7.527a9.536 9.536 0 0 1-1.32.543C16.925 8.655 14.563 9 12 9c-2.563 0-4.925-.345-6.68-.93A9.536 9.536 0 0 1 4 7.527V12c0 .002 0 .007.003.018a.298.298 0 0 0 .033.067c.042.07.127.173.288.3.328.26.864.537 1.618.789 1.497.5 3.635.826 6.058.826s4.561-.326 6.058-.826c.754-.252 1.29-.53 1.618-.789.16-.127.246-.23.288-.3a.298.298 0 0 0 .033-.067A.061.061 0 0 0 20 12V7.527Zm0 7.005a9.52 9.52 0 0 1-1.308.539C16.939 15.656 14.577 16 12 16s-4.939-.344-6.692-.929A9.461 9.461 0 0 1 4 14.531V19c0 .002 0 .007.003.018a.298.298 0 0 0 .033.067c.042.07.127.173.288.3.328.26.864.537 1.618.789 1.497.5 3.635.826 6.058.826s4.561-.326 6.058-.826c.754-.252 1.29-.53 1.618-.789.16-.127.246-.23.288-.3a.298.298 0 0 0 .033-.067A.061.061 0 0 0 20 19v-4.468Z",
      clipRule: "evenodd"
    })]
  }));
};

const Date = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16 1a1 1 0 0 1 1 1v1h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1ZM7 5v1a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0V5h2a1 1 0 0 1 1 1v3H4V6a1 1 0 0 1 1-1h2Zm13 6v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Z",
      clipRule: "evenodd"
    })]
  }));
};

const Delete = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M18.707 8.293a1 1 0 0 1 0 1.414L16.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L15 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L13.586 12l-2.293-2.293a1 1 0 0 1 1.414-1.414L15 10.586l2.293-2.293a1 1 0 0 1 1.414 0ZM7.247 3.342A1 1 0 0 1 8 3h13a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H8a1 1 0 0 1-.753-.341l-7-8a1 1 0 0 1 0-1.318l7-8ZM8.454 5l-6.125 7 6.125 7H21a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H8.454Z"
    })]
  }));
};

const DeleteActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8 3a1 1 0 0 0-.753.341l-7 8a1 1 0 0 0 0 1.318l7 8A1 1 0 0 0 8 21h13a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H8Zm10.707 5.293a1 1 0 0 1 0 1.414L16.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L15 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L13.586 12l-2.293-2.293a1 1 0 0 1 1.414-1.414L15 10.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Disc = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
    })]
  }));
};

const DollarSign = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13 1a1 1 0 1 0-2 0v3H9.5a4.5 4.5 0 0 0 0 9H11v5H6a1 1 0 1 0 0 2h5v3a1 1 0 1 0 2 0v-3h1.5a4.5 4.5 0 1 0 0-9H13V6h4a1 1 0 1 0 0-2h-4V1Zm-2 5H9.5a2.5 2.5 0 1 0 0 5H11V6Zm2 7v5h1.5a2.5 2.5 0 0 0 0-5H13Z",
      clipRule: "evenodd"
    })]
  }));
};

const Download = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13 2.857C13 2.384 12.552 2 12 2s-1 .384-1 .857v9.729L7.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L13 12.586V2.857ZM3 14a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1Z"
    })]
  }));
};

const DownloadCloud = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 26 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13.627 2.756A9 9 0 0 0 3.251 16.953a1 1 0 1 0 1.498-1.326A7 7 0 1 1 16.77 9.248a1 1 0 0 0 .97.752H19a4 4 0 0 1 2.304 7.272 1 1 0 0 0 1.15 1.636A6 6 0 0 0 19 8h-.518a9 9 0 0 0-4.854-5.244ZM13 11c.552 0 1 .366 1 .818v6.768l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L12 18.586v-6.768c0-.452.448-.818 1-.818Z"
    })]
  }));
};

const DragHandle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4 9a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm-1 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
    })]
  }));
};

const Droplet = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1.69a1 1 0 0 1 .707.293l5.66 5.66a9.001 9.001 0 1 1-12.724 0l5.65-5.66A1 1 0 0 1 12 1.69Zm0 2.415L7.058 9.057a7 7 0 1 0 9.896 0l-4.952-4.952Z",
      clipRule: "evenodd"
    })]
  }));
};

const Duration = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v5h-.01l.01.01L14 12l4 4-.01.01H18V21a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-5l4-4-4-3.99.01-.01H6V3Zm10 17v-3.5l-4-4-4 4V20h8ZM8 7.5V4h8v3.5l-4 4-4-4Z",
      clipRule: "evenodd"
    })]
  }));
};

const Edit = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20 .879c-.828 0-1.622.329-2.207.914l-9.5 9.5a1 1 0 0 0-.263.464l-1 4a1 1 0 0 0 1.213 1.213l4-1a1 1 0 0 0 .464-.263l9.5-9.5A3.121 3.121 0 0 0 20 .88Zm-.793 2.328a1.121 1.121 0 0 1 1.586 1.586l-9.304 9.304-2.115.529.529-2.115 9.304-9.304ZM4 3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 1 0-2 0v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7a1 1 0 1 0 0-2H4Z",
      clipRule: "evenodd"
    })]
  }));
};

const Edit2 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19 3.172a1.828 1.828 0 0 0-1.293.535L4.395 17.02l-.97 3.556 3.556-.97L20.293 6.293a1.827 1.827 0 0 0-.593-2.982 1.828 1.828 0 0 0-.7-.14Zm-1.465-1.709a3.829 3.829 0 0 1 4.172 6.244l-13.5 13.5a1 1 0 0 1-.444.258l-5.5 1.5a1 1 0 0 1-1.228-1.228l1.5-5.5a1 1 0 0 1 .258-.444l13.5-13.5a3.828 3.828 0 0 1 1.242-.83Z"
    })]
  }));
};

const Edit3 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M18 1.879c-.828 0-1.622.329-2.207.914l-12.5 12.5a1 1 0 0 0-.263.464l-1 4a1 1 0 0 0 1.213 1.213l4-1a1 1 0 0 0 .464-.263l12.5-12.5a3.12 3.12 0 0 0-1.012-5.09A3.121 3.121 0 0 0 18 1.878Zm-.793 2.328a1.121 1.121 0 0 1 1.586 1.586L6.489 18.097l-2.115.529.529-2.115L17.207 4.207ZM12 19a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Episodes = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M19.867 2H8.133C6.955 2 6 3.023 6 4.286V5h-.867A3.138 3.138 0 0 0 2 8.143v10.714A3.138 3.138 0 0 0 5.133 22h10.734A3.138 3.138 0 0 0 19 18.857V18h.867C21.045 18 22 16.977 22 15.714V4.286C22 3.023 21.045 2 19.867 2ZM17 18H8.133C6.955 18 6 16.977 6 15.714V7h-.867C4.512 7 4 7.507 4 8.143v10.714C4 19.493 4.512 20 5.133 20h10.734c.621 0 1.133-.508 1.133-1.143V18Zm-5.03-4.089a.73.73 0 0 1-.37-.638V6.727a.73.73 0 0 1 .37-.638.698.698 0 0 1 .726.027l4.977 3.272A.731.731 0 0 1 18 10a.731.731 0 0 1-.327.612l-4.977 3.272a.698.698 0 0 1-.726.027Z",
      clipRule: "evenodd"
    })]
  }));
};

const ExternalLink = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15 2a1 1 0 1 0 0 2h3.586l-9.293 9.293a1 1 0 1 0 1.414 1.414L20 5.414V9a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1h-6ZM5 7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 1 2 0v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h6a1 1 0 1 1 0 2H5Z"
    })]
  }));
};

const Eye = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.992 12a4 4 0 0 0 4.003 4 4 4 0 1 0 0-8 4 4 0 0 0-4.003 4Zm4.003 2a2 2 0 1 0 .002-4.002A2 2 0 0 0 11.995 14Zm11.9-2.45c.14.28.14.61 0 .9v.03l-.05.08c-.016.037-.04.079-.067.127a2.542 2.542 0 0 0-.083.153c-.13.23-.33.56-.58.96-.511.79-1.262 1.84-2.253 2.89-1.961 2.09-4.954 4.32-8.857 4.32-3.903 0-6.906-2.23-8.857-4.32A20.82 20.82 0 0 1 .896 13.8a16.41 16.41 0 0 1-.73-1.24l-.04-.08v-.02h-.02a1.032 1.032 0 0 1 0-.91v-.03l.05-.08c.015-.037.039-.079.067-.128.025-.044.054-.095.082-.152a20.246 20.246 0 0 1 2.832-3.85C5.09 5.23 8.093 3 11.996 3c3.903 0 6.906 2.23 8.857 4.32a20.776 20.776 0 0 1 2.252 2.89 16.4 16.4 0 0 1 .73 1.24l.04.08v.02h.02ZM19.4 8.68c.89.95 1.572 1.9 2.032 2.61.18.28.32.52.43.71-.11.19-.25.43-.43.71-.46.72-1.141 1.66-2.032 2.61-1.8 1.91-4.292 3.68-7.405 3.68-3.113 0-5.615-1.77-7.406-3.68-.89-.95-1.571-1.9-2.032-2.61-.18-.28-.32-.52-.43-.71.11-.19.25-.43.43-.71.46-.72 1.141-1.66 2.032-2.61C6.39 6.77 8.882 5 11.995 5c3.113 0 5.615 1.77 7.406 3.68Z",
      clipRule: "evenodd"
    })]
  }));
};

const EyeOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.707.293A1 1 0 0 0 .293 1.707l4.275 4.276a19.45 19.45 0 0 0-4.45 5.544 1 1 0 0 0-.012.92l.861-.43c-.861.43-.86.432-.86.432v.002l.004.007.011.022.04.078c.036.065.086.159.152.276a20.682 20.682 0 0 0 2.831 3.85C5.105 18.774 8.1 21 12 21h.016a11.07 11.07 0 0 0 5.81-1.76l4.467 4.467a1 1 0 0 0 1.414-1.414l-22-22Zm14.664 17.493-2.321-2.322a3.993 3.993 0 0 1-3.623.32A4 4 0 0 1 8.536 9.95L5.987 7.401a17.45 17.45 0 0 0-3.844 4.602 18.68 18.68 0 0 0 2.462 3.313c1.789 1.909 4.29 3.68 7.387 3.684a9.07 9.07 0 0 0 4.38-1.214Zm-6.343-6.344a2 2 0 0 0 2.53 2.53l-2.53-2.53Zm.1-6.228A8.12 8.12 0 0 1 11.998 5H12c3.1 0 5.605 1.774 7.395 3.684a18.676 18.676 0 0 1 2.463 3.314c-.517.9-1.114 1.753-1.783 2.548a1 1 0 0 0 1.53 1.288 19.505 19.505 0 0 0 2.277-3.363 1 1 0 0 0 .012-.918L23 12c.894-.447.894-.449.894-.449l-.002-.002-.003-.007-.011-.022a9.13 9.13 0 0 0-.192-.354 20.676 20.676 0 0 0-2.831-3.85C18.895 5.226 15.9 3 12 3a10.12 10.12 0 0 0-2.329.266 1 1 0 0 0 .456 1.948Zm11.895 6.785h-.044l-.121-.001.165.001Zm.035 0h-.035.035Zm.229 0h-.229.229ZM22.5 12h-.213.213Z",
      clipRule: "evenodd"
    })]
  }));
};

const Facebook = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13.5 9.25v-2a1.5 1.5 0 0 1 1.5-1.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2A4.5 4.5 0 0 0 9 6.5v2.75H7a1 1 0 0 0-1 1V12a1 1 0 0 0 1 1h2v8a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1v-8h2.323a1 1 0 0 0 .928-.629l.7-1.75a1 1 0 0 0-.928-1.371H13.5Z"
    })]
  }));
};

const FastForward = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.56 4.102a1 1 0 0 1 1.054.109l9 7a1 1 0 0 1 0 1.578l-9 7A1 1 0 0 1 12 19V5a1 1 0 0 1 .56-.898Zm-11 0a1 1 0 0 1 1.054.109l9 7a1 1 0 0 1 0 1.578l-9 7A1 1 0 0 1 1 19V5a1 1 0 0 1 .56-.898Z"
    })]
  }));
};

const FastRewind = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M22.44 4.102A1 1 0 0 1 23 5v14a1 1 0 0 1-1.614.79l-9-7a1 1 0 0 1 0-1.58l9-7a1 1 0 0 1 1.053-.108Zm-11 0A1 1 0 0 1 12 5v14a1 1 0 0 1-1.614.79l-9-7a1 1 0 0 1 0-1.58l9-7a1 1 0 0 1 1.053-.108Z"
    })]
  }));
};

const Favorite = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M16.95 1.998c-.854 0-1.7.169-2.488.495l-.292.13a6.499 6.499 0 0 0-1.817 1.28L12 4.256l-.353-.353a6.501 6.501 0 1 0-9.194 9.194l8.84 8.84a1 1 0 0 0 1.414 0l8.84-8.84a6.498 6.498 0 0 0 0-9.194 6.499 6.499 0 0 0-4.597-1.905Zm0 2a4.5 4.5 0 0 1 4.16 6.225l-.104.23a4.5 4.5 0 0 1-.873 1.23L12 19.815l-8.133-8.132a4.501 4.501 0 0 1 6.366-6.366l1.06 1.06a1 1 0 0 0 1.414 0l1.06-1.06a4.5 4.5 0 0 1 3.183-1.319Z"
    })]
  }));
};

const FavoriteActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M14.462 2.493a6.499 6.499 0 0 1 8.495 3.519 6.499 6.499 0 0 1-1.41 7.085l-8.84 8.84a1 1 0 0 1-1.414 0l-8.84-8.84a6.501 6.501 0 1 1 9.194-9.194l.353.353.353-.353a6.499 6.499 0 0 1 1.817-1.28l.292-.13Z"
    })]
  }));
};

const Feather = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.043 3.043a7.003 7.003 0 0 1 9.905 9.903v.001l-2.654 2.662c-.053.068-.115.13-.183.183l-3.903 3.914A1 1 0 0 1 13.5 20H5.414l-2.707 2.707a1 1 0 0 1-1.414-1.414L4 18.586V10.5a1 1 0 0 1 .293-.707l6.75-6.75ZM17.073 14l2.459-2.466v-.001a5.003 5.003 0 0 0-7.075-7.076L6 10.914v5.672l9.293-9.293a1 1 0 1 1 1.414 1.414L11.414 14h5.66Zm-7.659 2h5.665l-1.994 2h-5.67l2-2Z",
      clipRule: "evenodd"
    })]
  }));
};

const Feedback = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Zm0 8a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12ZM2.879 2.879A3 3 0 0 1 5 2h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7.414l-3.707 3.707A1 1 0 0 1 2 21V5a3 3 0 0 1 .879-2.121ZM5 4a1 1 0 0 0-1 1v13.586l2.293-2.293A1 1 0 0 1 7 16h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z"
    })]
  }));
};

const Figma = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5.672 16A4.5 4.5 0 1 0 13 19.5v-3.258a4.509 4.509 0 0 0 2.5.758 4.501 4.501 0 0 0 2.828-8A4.493 4.493 0 0 0 20 5.5 4.5 4.5 0 0 0 15.5 1h-7a4.5 4.5 0 0 0-2.828 8 4.502 4.502 0 0 0 0 7ZM8.5 3a2.5 2.5 0 1 0 0 5H11V3H8.5ZM11 17H8.5a2.5 2.5 0 1 0 2.5 2.5V17Zm-2.5-7a2.5 2.5 0 0 0 0 5H11v-5H8.5Zm4.5 2.5a2.5 2.5 0 1 0 5.001 0 2.5 2.5 0 0 0-5.001 0ZM15.5 8a2.5 2.5 0 1 0 0-5H13v5h2.5Z",
      clipRule: "evenodd"
    })]
  }));
};

const File = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V9a1 1 0 0 0-.293-.707l-7-7A1 1 0 0 0 13 1H6Zm-.707 2.293A1 1 0 0 1 6 3h6v6a1 1 0 0 0 1 1h6v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 .293-.707ZM17.586 8 14 4.414V8h3.586Z",
      clipRule: "evenodd"
    })]
  }));
};

const FileMinus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3.879 1.879A3 3 0 0 1 6 1h8a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 21 8v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 .879-2.121ZM6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5a1 1 0 0 1-1-1V3H6Zm9 1.414L17.586 7H15V4.414ZM9 14a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z",
      clipRule: "evenodd"
    })]
  }));
};

const FilePlus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a1 1 0 0 0-.293-.707l-6-6A1 1 0 0 0 14 1H6Zm-.707 2.293A1 1 0 0 1 6 3h7v5a1 1 0 0 0 1 1h5v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 .293-.707ZM17.586 7 15 4.414V7h2.586ZM13 12a1 1 0 1 0-2 0v2H9a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z",
      clipRule: "evenodd"
    })]
  }));
};

const FileText = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3.879 1.879A3 3 0 0 1 6 1h8a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 21 8v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 .879-2.121ZM6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5a1 1 0 0 1-1-1V3H6Zm9 1.414V7h2.586L15 4.414ZM7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Zm-1 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Filter = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4 6a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm2 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm4 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z"
    })]
  }));
};

const Filter2 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.093 2.58A1 1 0 0 1 2 2h20a1 1 0 0 1 .764 1.646L15 12.826V21a1 1 0 0 1-1.447.894l-4-2A1 1 0 0 1 9 19v-6.174l-7.764-9.18a1 1 0 0 1-.143-1.067ZM4.155 4l6.609 7.814a1 1 0 0 1 .236.646v5.922l2 1V12.46a1 1 0 0 1 .236-.646L19.845 4H4.155Z",
      clipRule: "evenodd"
    })]
  }));
};

const Flag = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 3a1 1 0 0 1 .293-.707c.22-.22.614-.483 1.21-.721C5.407 1.21 6.564 1 8 1c1.25 0 2.15.215 3.71.812l.962.379.547.21.25.091.458.157C14.723 2.906 15.3 3 16 3c1.189 0 2.094-.165 2.754-.428l.12-.05.192-.09.074-.04.104-.062a.363.363 0 0 0 .049-.037l.085-.076C20.015 1.703 21 2.147 21 3v12a1 1 0 0 1-.293.707c-.22.22-.614.483-1.21.721-.903.362-2.06.572-3.497.572-1.25 0-2.15-.215-3.71-.812l-.962-.379-.547-.21a21.402 21.402 0 0 0-.25-.091l-.458-.157C9.277 15.094 8.7 15 8 15c-1.189 0-2.094.165-2.754.428a4.257 4.257 0 0 0-.12.05L5 15.537V22a1 1 0 0 1-1.993.117L3 22V3Zm5 0c-1.189 0-2.094.165-2.754.428-.085.035-.16.067-.224.097L5 3.536v9.86l.229-.066c.688-.188 1.491-.303 2.418-.326L8 13c1.25 0 2.15.215 3.71.812l.962.379.547.21.25.091.458.157C14.723 14.906 15.3 15 16 15c1.189 0 2.094-.165 2.754-.428.085-.035.16-.067.224-.097l.022-.012v-9.86l-.229.067c-.688.188-1.491.303-2.418.326L16 5c-1.25 0-2.15-.215-3.71-.812l-.962-.379-.547-.21a22.377 22.377 0 0 0-.25-.091l-.458-.157C9.277 3.094 8.7 3 8 3Z"
    })]
  }));
};

const Folder = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M4 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-9a1 1 0 0 1-.832-.445L8.465 4H4ZM1.879 2.879A3 3 0 0 1 4 2h5a1 1 0 0 1 .832.445L11.535 5H20a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V5a3 3 0 0 1 .879-2.121Z",
      clipRule: "evenodd"
    })]
  }));
};

const FolderMinus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-8.465L9.832 2.445A1 1 0 0 0 9 2H4Zm-.707 2.293A1 1 0 0 1 4 4h4.465l1.703 2.555A1 1 0 0 0 11 7h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 .293-.707ZM9 13a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z",
      clipRule: "evenodd"
    })]
  }));
};

const FolderPlus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.879 2.879A3 3 0 0 1 4 2h5a1 1 0 0 1 .832.445L11.535 5H20a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V5a3 3 0 0 1 .879-2.121ZM4 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-9a1 1 0 0 1-.832-.445L8.465 4H4Zm8 6a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Forward10 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.97 9c.687 0 1.242.282 1.611.846.354.537.506 1.271.506 2.152 0 .905-.145 1.65-.491 2.177-.365.558-.93.825-1.626.825-.682 0-1.235-.28-1.604-.838-.352-.536-.502-1.275-.502-2.164 0-.91.143-1.658.488-2.181.365-.553.928-.817 1.618-.817Zm-.305 4.65a.54.54 0 0 1-.2-.223c-.13-.25-.22-.707-.22-1.429 0-.723.09-1.177.22-1.421a.54.54 0 0 1 .2-.224.585.585 0 0 1 .305-.071c.14 0 .237.03.308.072a.53.53 0 0 1 .198.226l.002.003c.132.25.222.703.222 1.415 0 .712-.09 1.17-.224 1.426a.536.536 0 0 1-.198.226.586.586 0 0 1-.308.072.584.584 0 0 1-.305-.072ZM13.828.293a1 1 0 1 0-1.414 1.414l.294.294h-.713a10 10 0 1 0 9.434 13.332 1 1 0 0 0-1.886-.666 8 8 0 1 1-7.546-10.665L12.949 4l-.535.535a1 1 0 0 0 1.414 1.414l2.122-2.122a1 1 0 0 0 0-1.414L13.828.293Zm4 0a1 1 0 1 0-1.414 1.414l1.414 1.414-1.414 1.415a1 1 0 0 0 1.414 1.414l2.122-2.122a1 1 0 0 0 0-1.414L17.828.293ZM10.266 14.93a.391.391 0 0 0 .392-.392V9.471a.391.391 0 0 0-.392-.391h-.498a.391.391 0 0 0-.235.078l-1.377 1.037a.392.392 0 0 0-.071.556l.313.395c.134.169.38.198.55.064l.35-.279v3.608c0 .216.176.392.392.392h.576Z",
      clipRule: "evenodd"
    })]
  }));
};

const Frown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM9 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H9Zm5 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm1.203 7.604A1 1 0 0 0 16.8 15.4l-.001-.001-.001-.002-.003-.004-.007-.009-.021-.027a5.77 5.77 0 0 0-.318-.361 6.951 6.951 0 0 0-.923-.805c-.798-.58-2-1.191-3.526-1.191-1.526 0-2.728.61-3.526 1.191a6.95 6.95 0 0 0-1.17 1.08c-.03.035-.053.064-.07.086l-.022.027-.007.01-.003.003-.001.002H7.2a1 1 0 0 0 1.597 1.205l.004-.006.034-.041a4.945 4.945 0 0 1 .815-.748c.578-.42 1.376-.81 2.35-.81.974 0 1.772.39 2.35.81a4.945 4.945 0 0 1 .815.748l.033.041.005.006Z",
      clipRule: "evenodd"
    })]
  }));
};

const Fullscreen = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2.879 2.879A3 3 0 0 1 5 2h3a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v3a1 1 0 0 1-2 0V5a3 3 0 0 1 .879-2.121ZM15 3a1 1 0 0 1 1-1h3a3 3 0 0 1 3 3v3a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1h-3a1 1 0 0 1-1-1ZM3 15a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h3a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3v-3a1 1 0 0 1 1-1Zm18 0a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h3a1 1 0 0 0 1-1v-3a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const FullscreenExit = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8 2a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H3a1 1 0 0 1 0-2h3a1 1 0 0 0 1-1V3a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h3a1 1 0 1 1 0 2h-3a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1ZM2 16a1 1 0 0 1 1-1h3a3 3 0 0 1 3 3v3a1 1 0 1 1-2 0v-3a1 1 0 0 0-1-1H3a1 1 0 0 1-1-1Zm16 1a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0v-3a3 3 0 0 1 3-3h3a1 1 0 1 1 0 2h-3Z",
      clipRule: "evenodd"
    })]
  }));
};

const Game = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm0 10H3V8h18v8ZM8 15H6v-2H4v-2h2V9h2v2h2v2H8v2Zm6.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm2.5-1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Gift = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.061 4.018C12.807 2.662 14.194 1 16.5 1a3.5 3.5 0 0 1 3.162 5H22a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2.338A3.5 3.5 0 0 1 7.5 1c2.306 0 3.693 1.662 4.439 3.018l.061.113.061-.113ZM11 8H3v3h8V8Zm-.346-2a8.208 8.208 0 0 0-.468-1.018C9.557 3.838 8.694 3 7.5 3a1.5 1.5 0 0 0 0 3h3.154Zm6.907-.44A1.5 1.5 0 0 1 16.5 6h-3.154c.122-.32.277-.67.468-1.018C14.443 3.838 15.306 3 16.5 3a1.5 1.5 0 0 1 1.06 2.56ZM13 11V8h8v3h-8Zm0 10h6v-8h-6v8Zm-2-8v8H5v-8h6Z",
      clipRule: "evenodd"
    })]
  }));
};

const GitBranch = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M22 6a4.002 4.002 0 0 1-3.04 3.884 10 10 0 0 1-9.076 9.077A4.002 4.002 0 0 1 2 18a4.002 4.002 0 0 1 3-3.874V3a1 1 0 0 1 2 0v11.126a4.007 4.007 0 0 1 2.862 2.827 8 8 0 0 0 7.091-7.091A4.002 4.002 0 0 1 18 2a4 4 0 0 1 4 4Zm-4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
      clipRule: "evenodd"
    })]
  }));
};

const GitCommit = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.1 12.995A1.013 1.013 0 0 1 7 13H1.05a1 1 0 1 1 0-2H7c.033 0 .067.002.1.005a5.002 5.002 0 0 1 9.801 0 1.31 1.31 0 0 1 .11-.005h5.95a1 1 0 1 1 0 2h-5.95a.987.987 0 0 1-.11-.006 5.002 5.002 0 0 1-9.802.001ZM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const GitPullRequest = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7 9.874A4.002 4.002 0 0 0 6 2a4 4 0 0 0-1 7.874V21a1 1 0 1 0 2 0V9.874ZM4 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8 0a1 1 0 0 1 1-1h3a3 3 0 0 1 3 3v6.126A4.002 4.002 0 0 1 18 22a4 4 0 0 1-1-7.874V8a1 1 0 0 0-1-1h-3a1 1 0 0 1-1-1Zm4 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Globe = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.015 23C18.083 22.992 23 18.07 23 12c0-6.075-4.925-11-11-11S1 5.925 1 12c0 6.07 4.917 10.992 10.985 11H12M9.726 3.29A9.008 9.008 0 0 0 3.055 11H7.05a16.3 16.3 0 0 1 2.676-7.71Zm4.548 0A16.3 16.3 0 0 1 16.95 11h3.995a9.008 9.008 0 0 0-6.67-7.71Zm.668 7.71A14.3 14.3 0 0 0 12 3.55 14.3 14.3 0 0 0 9.058 11h5.884Zm-5.884 2h5.884A14.3 14.3 0 0 1 12 20.45 14.3 14.3 0 0 1 9.058 13ZM7.05 13H3.055a9.008 9.008 0 0 0 6.67 7.71A16.3 16.3 0 0 1 7.05 13Zm7.224 7.71A16.3 16.3 0 0 0 16.95 13h3.995a9.008 9.008 0 0 1-6.67 7.71Z",
      clipRule: "evenodd"
    })]
  }));
};

const Grid = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13 3a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V3Zm2 1v5h5V4h-5ZM3 13a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H3Zm1 7v-5h5v5H4Zm10-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-7Zm1 7v-5h5v5h-5ZM3 2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3Zm1 7V4h5v5H4Z",
      clipRule: "evenodd"
    })]
  }));
};

const HardDrive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.76 3H7.24a3.002 3.002 0 0 0-2.685 1.664v.001l-3.44 6.87A.996.996 0 0 0 1 12v6a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-6.038a.996.996 0 0 0-.115-.428l-3.44-6.869v-.001A3 3 0 0 0 16.76 3Zm3.62 8-2.724-5.442-.002-.003A1 1 0 0 0 16.76 5H7.24a1 1 0 0 0-.894.555l-.002.003L3.62 11h16.762ZM3 13v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-5H3Zm6 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm-3-1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Hash = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.11 2.006a1 1 0 0 1 .884 1.105L16.45 8H20a1 1 0 1 1 0 2h-3.772l-.444 4H20a1 1 0 1 1 0 2h-4.438l-.568 5.11a1 1 0 1 1-1.988-.22L13.55 16H9.562l-.568 5.11a1 1 0 0 1-1.988-.22L7.55 16H4a1 1 0 1 1 0-2h3.772l.444-4H4a1 1 0 0 1 0-2h4.438l.568-5.11a1 1 0 1 1 1.988.22L10.45 8h3.987l.568-5.11a1 1 0 0 1 1.104-.884ZM10.228 10l-.444 4h3.988l.444-4h-3.988Z",
      clipRule: "evenodd"
    })]
  }));
};

const Hd = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6Zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9Zm1.5 4.5h2v-3h-2v3Z"
    })]
  }));
};

const Headphones = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6.343 6.343A8 8 0 0 1 20 12v1h-2a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-7a10 10 0 0 0-20 0v7a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H4v-1a8 8 0 0 1 2.343-5.657ZM4 15v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H4Zm16 0h-2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4Z",
      clipRule: "evenodd"
    })]
  }));
};

const HelpCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-1 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm-.093-8.729A2 2 0 0 1 13.92 10c0 .47-.365.958-1.055 1.418a6.046 6.046 0 0 1-1.246.628l-.016.006a1 1 0 0 0 .633 1.897h.002l.001-.001.004-.002.011-.003.035-.012.116-.043a8.036 8.036 0 0 0 1.57-.806c.81-.54 1.945-1.55 1.945-3.081a4 4 0 0 0-7.773-1.333 1 1 0 1 0 1.886.664 2 2 0 0 1 .874-1.06Z",
      clipRule: "evenodd"
    })]
  }));
};

const HelpCircleActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11.258-3.976a2 2 0 0 0-2.224 1.308 1 1 0 0 1-1.887-.664 4 4 0 0 1 7.773 1.333c0 1.53-1.135 2.54-1.945 3.081a8.045 8.045 0 0 1-1.686.848l-.05.018h-.001s.005.247-.002 0a1 1 0 0 1-.633-1.896l.016-.006a5.763 5.763 0 0 0 .364-.147c.247-.11.568-.272.882-.481.69-.46 1.055-.949 1.055-1.418v-.002a2 2 0 0 0-1.662-1.974ZM11 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Hexagon = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.502 1.403a3 3 0 0 1 2.998.001l7 4A3 3 0 0 1 22 7.999v8.002a3 3 0 0 1-1.5 2.595l-.004.002-6.996 3.998-.002.001a3 3 0 0 1-2.996 0l-.002-.001-6.996-3.998-.004-.002A3 3 0 0 1 2 16.001V7.999a3 3 0 0 1 1.5-2.595l.004-.002 6.998-4ZM12 3.002a1 1 0 0 0-.5.134l-.004.002L4.5 7.136h-.002A1 1 0 0 0 4 8.002V16a1 1 0 0 0 .498.864l.002.001 7 4a1 1 0 0 0 1 0l.004-.002 6.996-3.998h.002A1.001 1.001 0 0 0 20 16V8.001a1 1 0 0 0-.498-.864l-.002-.001-7-4a1 1 0 0 0-.5-.134Z",
      clipRule: "evenodd"
    })]
  }));
};

const HighQuality = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6Zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4Zm-3.5-.5h2v-3h-2v3Z"
    })]
  }));
};

const History = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M10.605 2.098a10 10 0 1 1-8.038 13.225 1 1 0 0 1 1.886-.665A8 8 0 1 0 6.325 6.36L3.515 9H6a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v2.679l2.944-2.767a10 10 0 0 1 5.661-2.814ZM13 7a1 1 0 1 0-2 0v5.25a1 1 0 0 0 .6.916l4 1.75a1 1 0 0 0 .8-1.832L13 11.596V7Z"
    })]
  }));
};

const Home = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.614 1.21a1 1 0 0 0-1.228 0l-9 7A1 1 0 0 0 2 9v11a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a1 1 0 0 0-.386-.79l-9-7ZM16 21h3a1 1 0 0 0 1-1V9.49l-8-6.223-8 6.222V20a1 1 0 0 0 1 1h3v-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9Zm-6 0v-8h4v8h-4Z",
      clipRule: "evenodd"
    })]
  }));
};

const HomeActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.614 1.21a1 1 0 0 0-1.228 0l-9 7A1 1 0 0 0 2 9v11a3 3 0 0 0 3 3h3.5c.5 0 1-.5 1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v8c0 .5.5 1 1 1H19a3 3 0 0 0 3-3V9a1 1 0 0 0-.386-.79l-9-7Z"
    })]
  }));
};

const Icon4k = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-7 10.5h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.5Zm6 1.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15Z"
    })]
  }));
};

const Image = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 .65.937L15.292 9.293a1 1 0 0 1 1.414 0L20 12.586V5a1 1 0 0 0-1-1H5Zm14 16H7.414L16 11.414l4 4V19a1 1 0 0 1-1 1ZM8.5 6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM8 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Inbox = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.76 3H7.24a3.002 3.002 0 0 0-2.685 1.664v.001l-3.44 6.87A.996.996 0 0 0 1 12v6a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-6.038a.996.996 0 0 0-.115-.428l-3.44-6.869v-.001A3 3 0 0 0 16.76 3Zm3.62 8-2.724-5.442-.002-.003A1 1 0 0 0 16.76 5H7.24a1 1 0 0 0-.894.555L5.45 5.11l.894.448L3.62 11H8a1 1 0 0 1 .832.445L10.535 14h2.93l1.703-2.555A1 1 0 0 1 16 11h4.38ZM3 13v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-5h-4.465l-1.703 2.555A1 1 0 0 1 14 16h-4a1 1 0 0 1-.832-.445L7.465 13H3Z",
      clipRule: "evenodd"
    })]
  }));
};

const Info = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm0-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
      clipRule: "evenodd"
    })]
  }));
};

const Instagram = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9.74 7.519a5 5 0 1 1 4.606 8.876A5 5 0 0 1 9.74 7.519Zm2.743 1.47a3 3 0 1 0-.88 5.935 3 3 0 0 0 .88-5.935ZM17.5 5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM1 7a6 6 0 0 1 6-6h10a6 6 0 0 1 6 6v10a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6V7Zm6-4a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H7Z",
      clipRule: "evenodd"
    })]
  }));
};

const Interactive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m18.264 12.94-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5a5.51 5.51 0 0 0-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26l-1.84-.39-.1-.02c-.1-.02-.2-.03-.32-.03-.53 0-1.03.21-1.41.59l-1.4 1.42 5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18Zm-.35 2.85-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V7c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06ZM11.644 3.5c-1.93 0-3.5 1.57-3.5 3.5 0 .95.38 1.81 1 2.44V7a2.501 2.501 0 0 1 5 0v2.44c.62-.63 1-1.49 1-2.44 0-1.93-1.57-3.5-3.5-3.5Z",
      clipRule: "evenodd"
    })]
  }));
};

const Italic = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15.022 3H19a1 1 0 1 1 0 2h-3.307l-5.25 14H14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3.307l5.25-14H10a1 1 0 0 1 0-2h5.022Z"
    })]
  }));
};

const Key = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M21.707 1.293a1 1 0 0 1 0 1.414L20.414 4l2.293 2.293a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414 0L15.5 8.914l-2.746 2.747A6.5 6.5 0 0 1 2.9 20.09l-.007-.008a6.5 6.5 0 0 1 8.43-9.821l8.97-8.97a1 1 0 0 1 1.414 0ZM19 5.414 16.914 7.5 18.5 9.086 20.586 7 19 5.414ZM4.328 18.69a4.5 4.5 0 0 1 6.394-6.333 4.5 4.5 0 1 1-6.394 6.333Zm0 0 .003.004h-.007v-.007l.004.003Z",
      clipRule: "evenodd"
    })]
  }));
};

const Layers = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.447 1.106a1 1 0 0 0-.894 0l-10 5a1 1 0 0 0 0 1.788l10 5a1 1 0 0 0 .894 0l10-5a1 1 0 0 0 0-1.788l-10-5ZM12 10.882 4.236 7 12 3.118 19.764 7 12 10.882Zm-10.894.67a1 1 0 0 1 1.341-.447L12 15.883l9.553-4.777a1 1 0 0 1 .894 1.79l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1-.447-1.342Zm0 5a1 1 0 0 1 1.341-.447L12 20.883l9.553-4.777a1 1 0 0 1 .894 1.79l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1-.447-1.342Z",
      clipRule: "evenodd"
    })]
  }));
};

const Layout = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v3h16V5a1 1 0 0 0-1-1H5Zm15 6H10v10h9a1 1 0 0 0 1-1v-9ZM8 10H4v9a1 1 0 0 0 1 1h3V10Z",
      clipRule: "evenodd"
    })]
  }));
};

const LifeBuoy = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm3.968-5.618A8.962 8.962 0 0 0 3 12c0 2.125.736 4.078 1.968 5.618l2.86-2.86A4.977 4.977 0 0 1 7 12c0-1.02.305-1.967.828-2.757l-2.86-2.86Zm1.414-1.414 2.86 2.86A4.977 4.977 0 0 1 12 7c1.02 0 1.967.305 2.757.828l2.86-2.86A8.962 8.962 0 0 0 12 3a8.962 8.962 0 0 0-5.618 1.968ZM17 12c0-1.02-.305-1.967-.828-2.757l2.86-2.86A8.962 8.962 0 0 1 21 12a8.962 8.962 0 0 1-1.968 5.618l-2.86-2.86A4.984 4.984 0 0 0 17 12Zm-5 9a8.962 8.962 0 0 1-5.618-1.968l2.86-2.86A4.984 4.984 0 0 0 12 17c1.02 0 1.967-.305 2.757-.828l2.86 2.86A8.962 8.962 0 0 1 12 21Zm0-12a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Link = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M16.996 1.067a6 6 0 0 0-4.22 1.684l-.011.01-1.72 1.71a1 1 0 0 0 1.41 1.418l1.715-1.705a4 4 0 0 1 5.656 5.655l-2.993 2.994a4.003 4.003 0 0 1-6.032-.432 1 1 0 1 0-1.602 1.198 5.999 5.999 0 0 0 9.048.648l3-3 .012-.012a6 6 0 0 0-4.263-10.168ZM10.425 8.01a6 6 0 0 0-4.672 1.743l-3 3-.012.012a6 6 0 0 0 8.484 8.484l.012-.012 1.71-1.71a1 1 0 0 0-1.414-1.414l-1.704 1.703a4 4 0 0 1-5.655-5.655l2.993-2.994a4 4 0 0 1 6.032.432 1 1 0 1 0 1.602-1.198 6 6 0 0 0-4.376-2.39Z"
    })]
  }));
};

const Link2 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3.172 9.172A4 4 0 0 1 6 8h3a1 1 0 1 0 0-2H6a6 6 0 1 0 0 12h3a1 1 0 1 0 0-2H6a4 4 0 0 1-2.828-6.828ZM15 6a1 1 0 1 0 0 2h3a4 4 0 1 1 0 8h-3a1 1 0 1 0 0 2h3a6 6 0 0 0 0-12h-3Zm-7 5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z"
    })]
  }));
};

const Linkedin = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M2.4 4.704a2.305 2.305 0 0 1 4.608 0c0 1.272-1.032 2.328-2.304 2.328-1.272 0-2.304-1.056-2.304-2.328Zm14.424 3.768c4.032 0 4.776 2.615 4.776 6.096l.145 5.984a1 1 0 0 1-1 1.024h-2.13a1 1 0 0 1-1-1v-5.24c0-1.488-.023-3.384-2.063-3.384-2.064 0-2.376 1.608-2.376 3.288v5.36a1 1 0 0 1-1 1h-1.984a1 1 0 0 1-1-1V9.784a1 1 0 0 1 1-1h1.816a1 1 0 0 1 1 1v.752h.048c.528-1.008 1.824-2.064 3.768-2.064ZM2.712 9.784a1 1 0 0 1 1-1h1.984a1 1 0 0 1 1 1V20.6a1 1 0 0 1-1 1H3.712a1 1 0 0 1-1-1V9.784Z"
    })]
  }));
};

const List = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7 6a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm-4 5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H3Zm5 0a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H8Zm-5-6a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H3Zm0-6a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H3Z"
    })]
  }));
};

const Loader = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V2Zm6.777 3.637a1 1 0 0 0-1.414-1.414l-2.83 2.83a1 1 0 0 0 1.414 1.414l2.83-2.83ZM1 12a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm17-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-9.533 4.533a1 1 0 0 1 0 1.414l-2.83 2.83a1 1 0 0 1-1.414-1.414l2.83-2.83a1 1 0 0 1 1.414 0Zm8.48 0a1 1 0 0 0-1.414 1.414l2.83 2.83a1 1 0 0 0 1.414-1.414l-2.83-2.83ZM13 18a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4ZM4.223 4.223a1 1 0 0 1 1.414 0l2.83 2.83a1 1 0 0 1-1.414 1.414l-2.83-2.83a1 1 0 0 1 0-1.414Z"
    })]
  }));
};

const Location = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm1.445 13.832h1.111l.002-.002.007-.005.023-.015.082-.057c.072-.05.174-.12.302-.214a31.433 31.433 0 0 0 4.254-3.727C19.516 17.397 22 13.903 22 10a10 10 0 0 0-20 0c0 3.902 2.484 7.396 4.774 9.813a31.428 31.428 0 0 0 4.254 3.726 18.887 18.887 0 0 0 .384.27l.023.016.007.005.003.002ZM6.343 4.343A8 8 0 0 1 20 10c0 3.098-2.016 6.104-4.226 8.437A29.412 29.412 0 0 1 12 21.773a29.419 29.419 0 0 1-3.774-3.335C6.016 16.103 4 13.097 4 10a8 8 0 0 1 2.343-5.657Zm5.102 19.489h1.11a1 1 0 0 1-1.11 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Lock = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 10V7a6 6 0 1 1 12 0v3h1a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1Zm3.172-5.828A4 4 0 0 1 16 7v3H8V7a4 4 0 0 1 1.172-2.828ZM5 12a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H5Z",
      clipRule: "evenodd"
    })]
  }));
};

const LogIn = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15 2a1 1 0 1 0 0 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 1 0 0 2h4a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-4ZM9.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L12.586 13H2.857C2.384 13 2 12.552 2 12s.384-1 .857-1h9.729L9.293 7.707a1 1 0 0 1 0-1.414Z"
    })]
  }));
};

const LogOut = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4.293 4.293A1 1 0 0 1 5 4h4a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h4a1 1 0 1 0 0-2H5a1 1 0 0 1-1-1V5a1 1 0 0 1 .293-.707Zm11 2a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 13H8.857C8.384 13 8 12.552 8 12s.384-1 .857-1h9.729l-3.293-3.293a1 1 0 0 1 0-1.414Z"
    })]
  }));
};

const Mail = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M4 3C2.348 3 1 4.348 1 6v12c0 1.652 1.348 3 3 3h16c1.652 0 3-1.348 3-3V6c0-1.652-1.348-3-3-3H4Zm-.893 2.554C3.272 5.227 3.612 5 4 5h16c.388 0 .728.227.893.554L12 11.779 3.107 5.554ZM3 7.92V18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V7.92l-8.427 5.9a1 1 0 0 1-1.146 0L3 7.92Z",
      clipRule: "evenodd"
    })]
  }));
};

const Map = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8.465 1.115a.996.996 0 0 0-.976.025L.504 5.132A1 1 0 0 0 0 6v16a1 1 0 0 0 1.496.868l6.535-3.734 7.504 3.751a.994.994 0 0 0 .976-.026l6.985-3.99A1 1 0 0 0 24 18V2a1 1 0 0 0-1.496-.868l-6.536 3.734-7.503-3.751ZM7 3.723 2 6.58v13.697l5-2.857V3.723Zm2 13.659V3.618l6 3v13.764l-6-3Zm13 .038-5 2.857V6.58l5-2.857V17.42Z",
      clipRule: "evenodd"
    })]
  }));
};

const Meh = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5 2a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Zm6-5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1ZM9 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Menu = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm-1 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z"
    })]
  }));
};

const MessageCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13.055 2.002 12.5 2a9.378 9.378 0 0 0-4.25 1.007A9.496 9.496 0 0 0 3 11.5l.006.368a9.378 9.378 0 0 0 .695 3.213l.123.283-1.773 5.32-.03.106a1 1 0 0 0 1.295 1.159l5.319-1.774.285.124a9.498 9.498 0 0 0 12.075-4.552A9.377 9.377 0 0 0 22 11.497V11a9.507 9.507 0 0 0-2.764-6.236 9.48 9.48 0 0 0-6.18-2.762ZM12.497 4h.472l-.024-.002a7.48 7.48 0 0 1 7.057 7.057L20 11.5a7.382 7.382 0 0 1-.793 3.35A7.503 7.503 0 0 1 12.5 19a7.381 7.381 0 0 1-3.35-.793l-.121-.051a1 1 0 0 0-.645-.005L4.58 19.42l1.268-3.803a1 1 0 0 0-.056-.767A7.38 7.38 0 0 1 5 11.503a7.502 7.502 0 0 1 4.147-6.708A7.385 7.385 0 0 1 12.497 4Z"
    })]
  }));
};

const MessageSquare = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5 6a1 1 0 0 0-1 1v13.586l2.293-2.293A1 1 0 0 1 7 18h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5ZM2.879 4.879A3 3 0 0 1 5 4h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7.414l-3.707 3.707A1 1 0 0 1 2 23V7a3 3 0 0 1 .879-2.121Z",
      clipRule: "evenodd"
    })]
  }));
};

const MessageSquareActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 25",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M2.9 4.9C3.4 4.3 4.2 4 5 4h14c.8 0 1.6.3 2.1.9.6.5.9 1.3.9 2.1v10c0 .8-.3 1.6-.9 2.1-.5.6-1.3.9-2.1.9H7.4l-3.7 3.7c-.3.3-.7.4-1.1.2-.4-.1-.6-.5-.6-.9V7c0-.8.3-1.6.9-2.1Z"
    })]
  }));
};

const Mic = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9.172 1.172A4 4 0 0 1 16 4v8a4 4 0 1 1-8 0V4a4 4 0 0 1 1.172-2.828ZM12 2a2 2 0 0 0-2 2v8a2 2 0 0 0 4 0V4a2 2 0 0 0-2-2Zm0 16a6 6 0 0 0 6-6v-2a1 1 0 1 1 2 0v2a8 8 0 0 1-7 7.937V22h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2.063A8 8 0 0 1 4 12v-2a1 1 0 1 1 2 0v2a6 6 0 0 0 6 6Z",
      clipRule: "evenodd"
    })]
  }));
};

const MicOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 25",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M.293 1.293a1 1 0 0 1 1.32-.083l.094.083L17.495 17.08a1 1 0 0 1 .374.374l5.838 5.838a1 1 0 0 1-1.32 1.497l-.094-.083-5.359-5.359A8 8 0 0 1 13 20.988V23h3a1 1 0 0 1 .117 1.993L16 25H8a1 1 0 0 1-.117-1.993L8 23h3v-2.012a8.002 8.002 0 0 1-6.996-7.671L4 13v-2a1 1 0 0 1 1.993-.117L6 11v2.007a6 6 0 0 0 5.706 6.037 1 1 0 0 1 .588 0 6.006 6.006 0 0 0 3.212-1.124l-1.476-1.476a4.005 4.005 0 0 1-3.56.25A4 4 0 0 1 8 13v-2.586L.293 2.707a1 1 0 0 1 0-1.414Zm9.706 11.121 2.515 2.515-.124.03A2 2 0 0 1 10 13l-.001-.585Zm2.403-11.397A4 4 0 0 0 8.08 4.201a1 1 0 0 0 1.96.398l.045-.18A2 2 0 0 1 14 5v5.341l.007.117A1 1 0 0 0 16 10.34V5l-.006-.228a4 4 0 0 0-3.592-3.755ZM19 10a1 1 0 0 1 .993.883L20 11v2c0 .472-.043.943-.126 1.407a1 1 0 0 1-1.968-.354c.047-.26.076-.524.088-.789L18 13v-2a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Minus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const MinusCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z",
      clipRule: "evenodd"
    })]
  }));
};

const MinusSquare = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm5 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Monitor = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13 18h7a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h7v2H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2ZM3 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5Z",
      clipRule: "evenodd"
    })]
  }));
};

const Moon = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.584 11.416a6.062 6.062 0 0 1-.507-7.805 1.01 1.01 0 0 0-.905-1.607 10.101 10.101 0 0 0-6.295 17.12 10.1 10.1 0 0 0 17.119-6.296 1.009 1.009 0 0 0-1.607-.905 6.06 6.06 0 0 1-7.805-.507Zm-2.406 8.37a8.08 8.08 0 0 1-3.873-2.091A8.082 8.082 0 0 1 9.352 4.464a8.076 8.076 0 0 0 1.803 8.38 8.082 8.082 0 0 0 8.381 1.804 8.085 8.085 0 0 1-9.358 5.138Z",
      clipRule: "evenodd"
    })]
  }));
};

const MoreHorizontal = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm5 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    })]
  }));
};

const MoreVertical = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-2 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    })]
  }));
};

const MousePointer = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3.385 2.077a1 1 0 0 0-1.308 1.308l7.07 16.97a1 1 0 0 0 1.87-.063l1.993-5.868 5.283 5.283a1 1 0 0 0 1.414-1.414l-5.283-5.283 5.868-1.993a1 1 0 0 0 .063-1.87l-16.97-7.07Zm6.59 15.064L4.857 4.857l12.284 5.118-4.883 1.658a1 1 0 0 0-.625.625l-1.658 4.883Z",
      clipRule: "evenodd"
    })]
  }));
};

const Move = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 4.414V11h6.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L19.586 13H13v6.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 19.586V13H4.414l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L4.414 11H11V4.414L9.707 5.707a1 1 0 0 1-1.414-1.414l3-3Z"
    })]
  }));
};

const Music = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M21.646 2.237A1 1 0 0 1 22 3v13a4 4 0 1 1-2-3.465V4.18L10 5.847v12.156a4 4 0 1 1-2-3.468V5a1 1 0 0 1 .836-.986l12-2a1 1 0 0 1 .81.223ZM20 16a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM6 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
      clipRule: "evenodd"
    })]
  }));
};

const Navigation = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M22.707 1.293a1 1 0 0 1 .197 1.135l-9 19a1 1 0 0 1-1.874-.186l-1.855-7.417-7.418-1.855a1 1 0 0 1-.185-1.874l19-9a1 1 0 0 1 1.135.197ZM5.953 10.708l5.29 1.322a1 1 0 0 1 .727.728l1.322 5.289 6.606-13.945-13.945 6.606Z",
      clipRule: "evenodd"
    })]
  }));
};

const Navigation2 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1a1 1 0 0 1 .938.654l7 19a1 1 0 0 1-1.434 1.214L12 18.152l-6.504 3.716a1 1 0 0 1-1.434-1.214l7-19A1 1 0 0 1 12 1ZM6.887 18.77l4.617-2.638a1 1 0 0 1 .992 0l4.617 2.638L12 4.893 6.887 18.77Z",
      clipRule: "evenodd"
    })]
  }));
};

const Next = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M19 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1ZM4.567 3.099a1 1 0 0 1 1.058.12l10 8a1 1 0 0 1 0 1.562l-10 8A1 1 0 0 1 4 20V4a1 1 0 0 1 .567-.901Z",
      clipRule: "evenodd"
    })]
  }));
};

const Notification = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1a7 7 0 0 0-7 7c0 3.353-.717 5.435-1.378 6.646a5.937 5.937 0 0 1-.88 1.244 3.037 3.037 0 0 1-.305.284l-.003.002A1 1 0 0 0 3 18h18a1 1 0 0 0 .566-1.824l-.003-.002a3.03 3.03 0 0 1-.306-.283 5.931 5.931 0 0 1-.88-1.245C19.718 13.435 19 11.353 19 8a7 7 0 0 0-7-7Zm6.85 15H5.15c.075-.125.152-.257.228-.396C6.217 14.065 7 11.647 7 8a5 5 0 1 1 10 0c0 3.647.783 6.065 1.622 7.604.076.14.152.271.229.396Zm-7.715 4.498a1 1 0 1 0-1.73 1.004 3 3 0 0 0 5.19 0 1 1 0 1 0-1.73-1.004 1 1 0 0 1-1.73 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const NotificationActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 1a7 7 0 0 0-7 7c0 3.353-.717 5.435-1.378 6.646a5.937 5.937 0 0 1-.88 1.244 3.037 3.037 0 0 1-.305.284l-.003.002A1 1 0 0 0 3 18h18a1 1 0 0 0 .566-1.824l-.003-.002a3.03 3.03 0 0 1-.306-.283 5.931 5.931 0 0 1-.88-1.245C19.718 13.435 19 11.353 19 8a7 7 0 0 0-7-7Zm-.865 19.498a1 1 0 1 0-1.73 1.004 3 3 0 0 0 5.19 0 1 1 0 1 0-1.73-1.004 1 1 0 0 1-1.73 0Z"
    })]
  }));
};

const NotificationOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.707.293A1 1 0 0 0 .293 1.707L5.58 6.994 5 8.001c0 3.352-.717 5.434-1.378 6.645a5.936 5.936 0 0 1-.88 1.244 3.003 3.003 0 0 1-.305.284l-.003.002A1 1 0 0 0 3 18h13.586l5.707 5.707a1 1 0 0 0 1.414-1.414L6.981 5.567a1 1 0 0 0-.029-.029L1.707.293Zm5.29 8.118c-.057 3.419-.812 5.713-1.62 7.193A9.37 9.37 0 0 1 5.15 16h9.437l-7.59-7.59ZM11.663.999A7 7 0 0 1 19 8.027c-.025 1.59.176 3.176.595 4.71a1 1 0 1 1-1.93.527A18.89 18.89 0 0 1 17 7.988a5 5 0 0 0-7.775-4.156 1 1 0 1 1-1.11-1.664A7 7 0 0 1 11.663 1ZM9.768 20.135a1 1 0 0 1 1.367.363 1 1 0 0 0 1.73 0 1 1 0 1 1 1.73 1.004 3 3 0 0 1-5.19 0 1 1 0 0 1 .363-1.367Z",
      clipRule: "evenodd"
    })]
  }));
};

const NotificationOn = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.05 3.05A7 7 0 0 1 19 8c0 3.353.717 5.435 1.378 6.646.332.608.655 1.007.88 1.244a3.026 3.026 0 0 0 .306.284l.002.002A1 1 0 0 1 21 18H3a1 1 0 0 1-.566-1.824l.003-.002.052-.042c.053-.044.141-.123.254-.242.224-.237.547-.636.88-1.244C4.282 13.435 5 11.353 5 8a7 7 0 0 1 2.05-4.95Zm2.718 17.085a1 1 0 0 1 1.367.363 1 1 0 0 0 1.73 0 1 1 0 1 1 1.73 1.004 3 3 0 0 1-5.19 0 1 1 0 0 1 .363-1.367Z",
      clipRule: "evenodd"
    })]
  }));
};

const Octagon = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.153 1.293A1 1 0 0 1 7.86 1h8.28a1 1 0 0 1 .707.293l5.86 5.86A1 1 0 0 1 23 7.86v8.28a1 1 0 0 1-.293.707l-5.86 5.86a1 1 0 0 1-.707.293H7.86a1 1 0 0 1-.707-.293l-5.86-5.86A1 1 0 0 1 1 16.14V7.86a1 1 0 0 1 .293-.707l5.86-5.86ZM8.274 3 3 8.274v7.452L8.274 21h7.452L21 15.726V8.274L15.726 3H8.274Z",
      clipRule: "evenodd"
    })]
  }));
};

const Package = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1.002a3 3 0 0 0-1.498.4L7.306 3.23a1 1 0 0 0-.553.316l-3.25 1.857-.003.002a3 3 0 0 0-.937.848 1.002 1.002 0 0 0-.25.414A3 3 0 0 0 2 8v8.002a3 3 0 0 0 1.5 2.595l.004.002 6.996 3.998.002.001c.317.183.664.305 1.023.363a.995.995 0 0 0 .95 0c.36-.058.706-.18 1.023-.363h.002l6.996-3.999.004-.002a3 3 0 0 0 1.5-2.595V8a3 3 0 0 0-.314-1.333 1 1 0 0 0-.249-.413 3 3 0 0 0-.937-.849l-7-4-.002-.001a3 3 0 0 0-1.498-.4Zm1 19.576 6.5-3.714h.002a1.001 1.001 0 0 0 .498-.865V8.538l-7 4.049v7.991Zm-2-7.991-7-4.05V16a1 1 0 0 0 .498.864l.002.001 6.5 3.714v-7.991Zm1.5-9.45 6.461 3.691-2.456 1.42-6.944-4.004 1.935-1.106.004-.002a1 1 0 0 1 1 0Zm-.5 7.718 2.507-1.45L7.55 5.393 5.039 6.828l6.96 4.027Z",
      clipRule: "evenodd"
    })]
  }));
};

const Paperclip = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M15.78 2.388a3 3 0 0 0-2.123.88l-9.19 9.19a5.003 5.003 0 1 0 7.076 7.075l9.19-9.19a1 1 0 0 1 1.414 1.414l-9.19 9.19a7.003 7.003 0 0 1-9.904-9.904l9.19-9.19a5.002 5.002 0 0 1 7.074 7.074l-9.2 9.19a3.001 3.001 0 0 1-4.244-4.244l8.49-8.48a1 1 0 1 1 1.414 1.415l-8.49 8.48a1.003 1.003 0 0 0 .708 1.708 1 1 0 0 0 .708-.293l9.2-9.19a3.004 3.004 0 0 0-2.123-5.125Z",
      clipRule: "evenodd"
    })]
  }));
};

const Pause = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6Zm8 0a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4Z"
    })]
  }));
};

const PenTool = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.293 1.293a1 1 0 0 1 .96-.26l14.482 3.495a1 1 0 0 1 .746.776l1.153 5.765a1 1 0 0 1 1.073.224l3 3a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1-.224-1.073L5.304 17.48a1 1 0 0 1-.776-.746L1.032 2.253a1 1 0 0 1 .26-.96Zm7 8.414L3.805 5.22l2.516 10.425 6.35 1.27 4.242-4.244-1.27-6.349L5.22 3.806l4.487 4.486a3 3 0 1 1-1.414 1.414Zm1.988.598a1 1 0 1 0 .025-.025l-.013.013-.012.012Zm3.42 8.408.006-.006 5-5 .006-.005.287-.288L20.586 15 15 20.586 13.414 19l.288-.287Z",
      clipRule: "evenodd"
    })]
  }));
};

const Percent = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm13.293-2.207a1 1 0 1 1 1.414 1.414l-14 14a1 1 0 0 1-1.414-1.414l14-14ZM14 17.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
      clipRule: "evenodd"
    })]
  }));
};

const Phone = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7.1 1H4.11a3.005 3.005 0 0 0-2.84 2.043 3 3 0 0 0-.145 1.227 20.804 20.804 0 0 0 3.227 9.124 20.489 20.489 0 0 0 6.303 6.3 20.78 20.78 0 0 0 9.058 3.22A3 3 0 0 0 23 19.916V16.92a3 3 0 0 0-2.58-3.02 11.86 11.86 0 0 1-2.6-.647 2.998 2.998 0 0 0-1.68-.125l-.208.052c-.48.14-.918.396-1.275.75l-.721.718-.119-.074a15 15 0 0 1-4.39-4.391l-.076-.12.716-.716a3.005 3.005 0 0 0 .68-3.169A11.834 11.834 0 0 1 10.1 3.59 3.001 3.001 0 0 0 7.1 1ZM4.111 3h3a1 1 0 0 1 1.01.86 13.74 13.74 0 0 0 .752 3.02 1.002 1.002 0 0 1-.224 1.057L7.383 9.203a1 1 0 0 0-.162 1.201 17.001 17.001 0 0 0 6.375 6.375 1 1 0 0 0 1.201-.162l1.27-1.27a.994.994 0 0 1 1.051-.22c.98.365 1.997.618 3.031.755A1 1 0 0 1 21 16.896v3.024a1.005 1.005 0 0 1-.324.745 1.001 1.001 0 0 1-.766.26 18.776 18.776 0 0 1-8.176-2.914 18.51 18.51 0 0 1-5.7-5.697 18.8 18.8 0 0 1-2.92-8.24A1 1 0 0 1 4.111 3Z"
    })]
  }));
};

const PictureInPicture = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M4 3c-.842 0-1.618.383-2.167 1.011A3.46 3.46 0 0 0 1 6.286v11.428c0 .832.288 1.652.833 2.275C2.383 20.617 3.158 21 4 21h16c.842 0 1.618-.383 2.167-1.011A3.46 3.46 0 0 0 23 17.714V6.286a3.46 3.46 0 0 0-.833-2.275C21.617 3.383 20.842 3 20 3H4Zm-.662 2.328C3.54 5.098 3.781 5 4 5h16c.219 0 .46.098.662.328.204.234.338.577.338.958v11.428c0 .381-.134.724-.338.958-.201.23-.443.328-.662.328H4c-.219 0-.46-.098-.662-.328A1.463 1.463 0 0 1 3 17.714V6.286c0-.381.134-.724.338-.958ZM10.9 17h7.2a.92.92 0 0 0 .636-.251.837.837 0 0 0 .264-.606v-4.286a.837.837 0 0 0-.264-.606A.923.923 0 0 0 18.1 11h-7.2a.923.923 0 0 0-.636.251.837.837 0 0 0-.264.606v4.286c0 .227.095.445.264.606.168.16.397.251.636.251Z",
      clipRule: "evenodd"
    })]
  }));
};

const PictureInPictureExit = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M18.724 5.302c-.22-.177-.559-.302-.946-.302H11a1 1 0 1 1 0-2h6.778c.791 0 1.583.25 2.196.74C20.592 4.235 21 4.96 21 5.778V12h.7c.345 0 .675.136.92.377.243.24.38.568.38.909v6.428c0 .341-.137.668-.38.91a1.307 1.307 0 0 1-.92.376H11.3c-.345 0-.675-.136-.92-.377a1.278 1.278 0 0 1-.38-.909V19H4.222c-.791 0-1.583-.25-2.196-.74C1.408 17.765 1 17.04 1 16.222V13a1 1 0 1 1 2 0v3.222c0 .125.06.304.276.476.22.177.559.302.946.302H10v-3.714c0-.341.137-.668.38-.91.245-.24.575-.376.92-.376H19V5.778c0-.125-.06-.304-.276-.476ZM7 5a1 1 0 0 0 0-2H2a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V6.414l4.793 4.793a1 1 0 0 0 1.414-1.414L4.414 5H7Z"
    })]
  }));
};

const PieChart = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1A11 11 0 0 0 12 1Zm1 10V3.056A9 9 0 0 1 20.944 11H13ZM8.4 3.747a1 1 0 0 0-.8-1.834A11 11 0 1 0 22.131 16.28a1 1 0 0 0-1.842-.778A9.001 9.001 0 1 1 8.399 3.745Z",
      clipRule: "evenodd"
    })]
  }));
};

const Play = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5.52 2.122a1 1 0 0 1 1.02.037l14 9a1 1 0 0 1 0 1.682l-14 9A1 1 0 0 1 5 21V3a1 1 0 0 1 .52-.878Z",
      clipRule: "evenodd"
    })]
  }));
};

const Playlist = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H3Zm0 6a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H3Zm-1 7a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm15.578-2.937a.355.355 0 0 0-.383-.014.405.405 0 0 0-.195.351v7.2c0 .146.075.281.195.351.12.07.267.065.383-.015l5.25-3.6A.407.407 0 0 0 23 19a.407.407 0 0 0-.172-.337l-5.25-3.6Z"
    })]
  }));
};

const Plus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5Z",
      clipRule: "evenodd"
    })]
  }));
};

const PlusCircle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const PlusSquare = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Zm7 3a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Pocket = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20 2H4a3 3 0 0 0-3 3v6a11 11 0 1 0 22 0V5a3 3 0 0 0-3-3ZM3.293 4.293A1 1 0 0 1 4 4h16a1 1 0 0 1 1 1v6a9 9 0 0 1-18 0V5a1 1 0 0 1 .293-.707Zm5.414 5a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 12.586 8.707 9.293Z",
      clipRule: "evenodd"
    })]
  }));
};

const Podcast = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-.5 2.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm4 7.056C15.5 21.01 13.933 23 12 23s-3.5-1.99-3.5-4.444C8.5 16.1 8.5 15 12 15s3.5 1.101 3.5 3.556Zm-2 0C13.5 20.377 12.41 21 12 21c-.41 0-1.5-.623-1.5-2.444 0-.653.003-1.047.04-1.35l.011-.08c.236-.064.675-.126 1.449-.126s1.213.062 1.449.126l.011.08c.037.303.04.697.04 1.35ZM3 11.382C3 6.488 7.018 2.5 12 2.5s9 3.988 9 8.882c0 2.075-.72 3.981-1.927 5.494a1 1 0 0 0 1.562 1.248A10.767 10.767 0 0 0 23 11.382C23 5.362 18.064.5 12 .5S1 5.361 1 11.382c0 2.546.885 4.89 2.365 6.742a1 1 0 0 0 1.562-1.248A8.767 8.767 0 0 1 3 11.382ZM12 6.5c-2.785 0-5 2.195-5 4.85 0 .957.285 1.849.78 2.601a1 1 0 1 1-1.673 1.098A6.717 6.717 0 0 1 5 11.35C5 7.543 8.158 4.5 12 4.5s7 3.043 7 6.85a6.718 6.718 0 0 1-1.107 3.699 1 1 0 0 1-1.672-1.098A4.717 4.717 0 0 0 17 11.35c0-2.655-2.215-4.85-5-4.85Z",
      clipRule: "evenodd"
    })]
  }));
};

const Power = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M13 2a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V2ZM6.337 7.347a1 1 0 0 0-1.414-1.414 10 10 0 1 0 14.144 0 1 1 0 1 0-1.414 1.414 8 8 0 1 1-11.316 0Z"
    })]
  }));
};

const Previous = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M20 4a1 1 0 0 0-1.625-.78l-10 8a1 1 0 0 0 0 1.56l10 8A1 1 0 0 0 20 20V4ZM6 5a1 1 0 0 0-2 0v14a1 1 0 1 0 2 0V5Z"
    })]
  }));
};

const Printer = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 1a1 1 0 0 0-1 1v6H4a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3h1a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3h-1V2a1 1 0 0 0-1-1H6Zm11 7V3H7v5h10Zm3 2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v-3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h16Zm-3 5v6H7v-6h10Z",
      clipRule: "evenodd"
    })]
  }));
};

const PrivacyPolicy = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.351 1.064a1 1 0 0 0-.702 0l-8 3A1 1 0 0 0 3 5v7c0 3.446 2.282 6.2 4.341 8.003a22.686 22.686 0 0 0 4.104 2.836l.076.04.022.01.006.004.003.001c.282.14.614.141.895 0L12 22c.447.894.449.894.449.894l.002-.001.006-.004.022-.01a8.28 8.28 0 0 0 .35-.188 22.684 22.684 0 0 0 3.83-2.689C18.718 18.2 21 15.447 21 12V5a1 1 0 0 0-.649-.936l-8-3ZM12 22l-.448.894L12 22Zm.72-1.567c-.283.177-.528.321-.72.43a20.692 20.692 0 0 1-3.341-2.365C6.719 16.8 5 14.553 5 12V5.693l7-2.625 7 2.625V12c0 2.554-1.718 4.8-3.659 6.497a20.69 20.69 0 0 1-2.621 1.936Zm5.017-10.757a1 1 0 1 0-1.474-1.352l-4.746 5.177-2.764-3.16a1 1 0 0 0-1.506 1.318l3.5 4a1 1 0 0 0 1.49.017l5.5-6Z",
      clipRule: "evenodd"
    })]
  }));
};

const PrivacyPolicyActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.649 1.064a1 1 0 0 1 .702 0l8 3A1 1 0 0 1 21 5v7c0 3.446-2.282 6.2-4.341 8.003a22.684 22.684 0 0 1-4.104 2.836 8.28 8.28 0 0 1-.076.04l-.022.01-.006.004h-.002a1.079 1.079 0 0 1-.897.001l-.003-.001-.006-.004-.022-.01a8.28 8.28 0 0 1-.35-.188 22.686 22.686 0 0 1-3.83-2.689C5.281 18.2 3 15.447 3 12V5a1 1 0 0 1 .649-.936l8-3Zm-.097 21.83c.282.14.614.141.895 0-.21.106-.59.152-.895 0Zm6.124-14.631a1 1 0 0 1 .061 1.413l-5.5 6a1 1 0 0 1-1.49-.018l-3.5-4a1 1 0 1 1 1.506-1.316l2.764 3.16 4.746-5.178a1 1 0 0 1 1.413-.061Z",
      clipRule: "evenodd"
    })]
  }));
};

const Radio = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5.637 5.637a1 1 0 1 0-1.414-1.414 11 11 0 0 0 0 15.554 1 1 0 0 0 1.414-1.414 9 9 0 0 1 0-12.726Zm14.14-1.414a1 1 0 1 0-1.414 1.414 9 9 0 0 1 0 12.726 1 1 0 1 0 1.414 1.414 11 11 0 0 0 0-15.554ZM8.467 8.458a1 1 0 1 0-1.414-1.415 7 7 0 0 0 0 9.905 1 1 0 0 0 1.414-1.415 5.001 5.001 0 0 1 0-7.075Zm8.48-1.405a1 1 0 1 0-1.414 1.415 5 5 0 0 1 0 7.075 1 1 0 1 0 1.414 1.415 7 7 0 0 0 0-9.905Z",
      clipRule: "evenodd"
    })]
  }));
};

const RefreshCcw = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M14.212 2.249a10 10 0 0 0-9.268 2.673L2 7.688V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H3.525l2.8-2.631a8 8 0 0 1 13.222 2.965 1 1 0 0 0 1.886-.668 10 10 0 0 0-7.22-6.417ZM22 16.312V20a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h3.475l-2.8 2.631-.009.009-.013.013a8.001 8.001 0 0 1-13.2-2.987 1 1 0 0 0-1.886.668 10 10 0 0 0 16.489 3.744L22 16.312Z"
    })]
  }));
};

const RefreshCw = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M10.229 4.2a8 8 0 0 1 7.446 2.169L20.475 9H17a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v3.688l-2.944-2.766A10 10 0 0 0 2.567 8.666a1 1 0 0 0 1.886.668A8 8 0 0 1 10.229 4.2ZM3.525 15H7a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-3.688l2.944 2.766a10 10 0 0 0 16.489-3.744 1 1 0 0 0-1.886-.668 8 8 0 0 1-13.222 2.965L3.525 15Z"
    })]
  }));
};

const Repeat = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M16.293.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 6H7a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0V9a5 5 0 0 1 5-5h11.586l-2.293-2.293a1 1 0 0 1 0-1.414ZM21 12a1 1 0 0 0-1 1v2a3 3 0 0 1-3 3H5.414l2.293-2.293a1 1 0 1 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L5.414 20H17a5 5 0 0 0 5-5v-2a1 1 0 0 0-1-1Z"
    })]
  }));
};

const Replay = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M16.837 3.258A10 10 0 0 0 4.944 4.92L2 7.688V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H3.525l2.8-2.631.022-.021a8 8 0 1 1-1.894 8.32 1 1 0 0 0-1.886.664 10 10 0 1 0 14.27-12.074Z"
    })]
  }));
};

const Replay10 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.97 9c.687 0 1.243.282 1.612.846.353.537.505 1.271.505 2.152 0 .905-.145 1.65-.491 2.177-.365.558-.93.825-1.626.825-.682 0-1.235-.28-1.604-.838-.352-.536-.502-1.275-.502-2.164 0-.91.143-1.658.488-2.181.365-.553.928-.817 1.618-.817Zm-.305 4.65a.54.54 0 0 1-.2-.223c-.13-.25-.22-.707-.22-1.429 0-.723.09-1.177.22-1.421a.54.54 0 0 1 .2-.224.586.586 0 0 1 .305-.071c.14 0 .237.03.308.072a.53.53 0 0 1 .198.226l.002.003c.132.25.222.703.222 1.415 0 .712-.09 1.17-.224 1.426a.536.536 0 0 1-.198.226.586.586 0 0 1-.308.072.585.585 0 0 1-.305-.072ZM10.172.293a1 1 0 1 1 1.414 1.414l-.294.294h.713a10 10 0 1 1-9.434 13.332 1 1 0 0 1 1.886-.666 8 8 0 1 0 7.546-10.665L11.051 4l.535.535a1 1 0 0 1-1.414 1.414L8.05 3.828a1 1 0 0 1 0-1.414L10.172.293Zm-4 0a1 1 0 1 1 1.414 1.414L6.172 3.121l1.414 1.415A1 1 0 1 1 6.172 5.95L4.05 3.828a1 1 0 0 1 0-1.414L6.172.293Zm4.094 14.638a.391.391 0 0 0 .392-.392V9.471a.391.391 0 0 0-.392-.391h-.498a.391.391 0 0 0-.235.078l-1.377 1.037a.392.392 0 0 0-.071.556l.313.395c.134.169.38.198.55.064l.35-.279v3.608c0 .216.176.392.392.392h.576Z",
      clipRule: "evenodd"
    })]
  }));
};

const Reply = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M10 8.5v-4l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11Z"
    })]
  }));
};

const RotateCcw = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M16.837 3.258A10 10 0 0 0 4.944 4.92L2 7.688V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H3.524l2.8-2.631a8 8 0 1 1-1.872 8.299 1 1 0 0 0-1.885.664 10 10 0 1 0 14.27-12.074Z"
    })]
  }));
};

const RotateCw = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M8.141 4.996a8 8 0 0 1 9.543 1.372L20.48 9H17a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v3.685l-2.934-2.763a10 10 0 1 0 2.367 10.411 1 1 0 0 0-1.886-.666 8 8 0 1 1-11.406-9.67Z"
    })]
  }));
};

const Rss = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 4a1 1 0 0 1 1-1 17 17 0 0 1 17 17 1 1 0 1 1-2 0A15 15 0 0 0 4 5a1 1 0 0 1-1-1Zm0 7a1 1 0 0 1 1-1 10 10 0 0 1 10 10 1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1Zm2 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
    })]
  }));
};

const Scissors = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9.446 8.032a4 4 0 1 0-1.414 1.414L10.586 12l-2.554 2.554a4 4 0 1 0 1.414 1.414l11.261-11.26a1 1 0 0 0-1.414-1.415L12 10.586 9.446 8.032ZM6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7.762-2.226a1 1 0 0 1 1.414-.002l5.53 5.52a1 1 0 1 1-1.412 1.416l-5.53-5.52a1 1 0 0 1-.002-1.415Z",
      clipRule: "evenodd"
    })]
  }));
};

const Search = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.618 18.032a9 9 0 1 1 1.414-1.414l3.675 3.675a1 1 0 0 1-1.414 1.414l-3.675-3.675ZM4 11a7 7 0 1 1 12.042 4.856 1.012 1.012 0 0 0-.186.186A7 7 0 0 1 4 11Z",
      clipRule: "evenodd"
    })]
  }));
};

const Send = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M22.997 1.923a1 1 0 0 0-1.35-.859L1.67 8.056a1 1 0 0 0-.076 1.858l8.648 3.844 3.844 8.648a1 1 0 0 0 1.858-.076l6.993-19.98c.051-.137.071-.283.06-.427Zm-4.803 2.469L4.711 9.11l6.067 2.696 7.416-7.415Zm-6.001 8.83 7.416-7.416-4.72 13.483-2.696-6.068Z",
      clipRule: "evenodd"
    })]
  }));
};

const Server = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 4a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm2 14a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H6ZM6 5a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H6Zm-2 8a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3H4Zm-1 3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4Z",
      clipRule: "evenodd"
    })]
  }));
};

const Settings = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm10.315 3.404L19.4 15l.92.394a.65.65 0 0 1 .593-.394H21a3 3 0 0 0 0-6h-.168a.65.65 0 0 1-.533-.285 1.006 1.006 0 0 0-.064-.199.65.65 0 0 1 .127-.714l.055-.055a2.999 2.999 0 0 0-.973-4.895 3 3 0 0 0-3.271.651l-.055.055a.65.65 0 0 1-.714.127l-.01-.004A.65.65 0 0 1 15 3.087V3a3 3 0 0 0-6 0v.167a.65.65 0 0 1-.285.534 1 1 0 0 0-.199.064.65.65 0 0 1-.714-.127l-.054-.055a3 3 0 1 0-4.245 4.244l.055.055a.65.65 0 0 1 .127.714l-.024.059a.65.65 0 0 1-.585.425H3a3 3 0 1 0 0 6h.167a.65.65 0 0 1 .594.394l.004.01a.65.65 0 0 1-.127.714l-.055.055a3 3 0 0 0 3.27 4.895c.365-.151.696-.372.974-.651l.055-.055a.65.65 0 0 1 .714-.127l.059.023a.651.651 0 0 1 .425.586V21a3 3 0 1 0 6 0v-.168a.65.65 0 0 1 .394-.593l.01-.004a.65.65 0 0 1 .714.127l.055.055a2.999 2.999 0 0 0 4.895-.973 3 3 0 0 0-.651-3.271l-.055-.055a.65.65 0 0 1-.127-.714ZM11.293 2.293A1 1 0 0 1 13 3v.094a2.65 2.65 0 0 0 1.601 2.423 2.65 2.65 0 0 0 2.918-.532l.069-.068a1 1 0 0 1 1.415 0 .999.999 0 0 1 0 1.416l-.06.06-.008.008a2.65 2.65 0 0 0-.607 2.729c.012.09.037.18.073.264A2.65 2.65 0 0 0 20.826 11H21a1 1 0 0 1 0 2h-.094a2.65 2.65 0 0 0-2.423 1.601 2.65 2.65 0 0 0 .532 2.918l.068.069a1 1 0 0 1 0 1.415 1 1 0 0 1-1.416 0l-.06-.06-.008-.008a2.651 2.651 0 0 0-2.918-.532 2.65 2.65 0 0 0-1.601 2.423V21a1 1 0 0 1-2 0v-.113a2.65 2.65 0 0 0-1.705-2.415 2.651 2.651 0 0 0-2.894.543l-.069.068a.999.999 0 0 1-1.415 0 1 1 0 0 1 0-1.416l.06-.06.008-.008a2.65 2.65 0 0 0 .532-2.918 2.65 2.65 0 0 0-2.423-1.601H3a1 1 0 0 1 0-2h.113a2.65 2.65 0 0 0 2.414-1.705 2.65 2.65 0 0 0-.542-2.894l-.068-.069a1 1 0 0 1 0-1.415 1 1 0 0 1 1.416 0l.06.06.008.008a2.65 2.65 0 0 0 2.729.607 1 1 0 0 0 .264-.073A2.65 2.65 0 0 0 11 3.174V3a1 1 0 0 1 .293-.707Z",
      clipRule: "evenodd"
    })]
  }));
};

const Share = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.838 2.14a.499.499 0 0 0-.844.36v4.849c-1.248.073-2.373.295-3.398.723-1.303.544-2.384 1.397-3.328 2.589-.994 1.257-1.67 3.325-2.09 4.931C2.625 17.7 2.336 19.852 2 22c.948-1.067 1.852-2.197 2.891-3.178 1.907-1.8 4.402-3.472 7.103-3.516v4.82c0 .44.526.664.844.36l9.597-9.173-9.597-9.174Zm-.844 11.17 1.996-.001v3.287l5.527-5.283L13.99 6.03v3.287h-.998c-1.49 0-2.659.193-3.627.597-.956.399-1.773 1.027-2.531 1.985-.694.878-1.28 2.524-1.703 4.112 1.977-1.488 4.342-2.67 6.863-2.701Z",
      clipRule: "evenodd"
    })]
  }));
};

const ShareAndroid = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M15.158 7.815a4 4 0 1 0-1.008-1.727L8.842 9.185a4 4 0 1 0 0 5.63l5.309 3.093A4.003 4.003 0 0 0 18 23a4 4 0 1 0-2.839-6.818l-5.31-3.095a4.004 4.004 0 0 0 0-2.175l5.307-3.097ZM18 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM7.7 10.945a1.01 1.01 0 0 0 .056.097c.156.284.244.61.244.958a1.991 1.991 0 0 1-.3 1.054A1.999 1.999 0 0 1 4 12a2 2 0 0 1 3.7-1.055Zm8.515 7.152a1.015 1.015 0 0 0 .123-.21 2 2 0 1 1-.123.21Z",
      clipRule: "evenodd"
    })]
  }));
};

const ShareIos = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11.293 1.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 4.414v10.72c0 .478-.448.866-1 .866s-1-.388-1-.867V4.414L8.707 6.707a1 1 0 0 1-1.414-1.414l4-4ZM4 11a1 1 0 0 1 1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 1 1 2 0v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a1 1 0 0 1 1-1Z"
    })]
  }));
};

const Shield = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.649 1.064a1 1 0 0 1 .702 0l8 3A1 1 0 0 1 21 5v7c0 3.446-2.282 6.2-4.341 8.003a22.684 22.684 0 0 1-4.104 2.836 8.28 8.28 0 0 1-.076.04l-.022.01-.006.004h-.002s-.002.001-.449-.893l-.448.894-.003-.001-.006-.004-.022-.01a8.28 8.28 0 0 1-.35-.188 22.686 22.686 0 0 1-3.83-2.689C5.281 18.2 3 15.447 3 12V5a1 1 0 0 1 .649-.936l8-3ZM12 22l-.448.894c.282.14.614.141.895 0L12 22Zm0-1.137a20.69 20.69 0 0 0 3.341-2.365C17.282 16.8 19 14.553 19 12V5.693l-7-2.625-7 2.625V12c0 2.554 1.718 4.8 3.659 6.497A20.692 20.692 0 0 0 12 20.863Z",
      clipRule: "evenodd"
    })]
  }));
};

const ShieldOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.707.293A1 1 0 0 0 .293 1.707l2.824 2.824A.998.998 0 0 0 3 5v7c0 3.446 2.282 6.2 4.341 8.003a22.686 22.686 0 0 0 4.104 2.836l.076.04.022.01.006.004.004.001a1 1 0 0 0 .914-.01 21.287 21.287 0 0 0 5.173-3.83l4.653 4.653a1 1 0 0 0 1.414-1.414l-22-22ZM16.226 17.64 5 6.414V12c0 2.553 1.718 4.8 3.659 6.497a20.69 20.69 0 0 0 3.34 2.365 19.287 19.287 0 0 0 4.227-3.222ZM11.65 1.063a1 1 0 0 1 .701 0l8 3A1 1 0 0 1 21 5v7.007a7.896 7.896 0 0 1-.355 2.29 1 1 0 1 1-1.91-.593A5.897 5.897 0 0 0 19 11.997V5.693l-7-2.625-2.81 1.049a1 1 0 0 1-.7-1.874l3.16-1.18Z",
      clipRule: "evenodd"
    })]
  }));
};

const ShoppingBag = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5.2 1.4A1 1 0 0 1 6 1h12a1 1 0 0 1 .8.4l2.994 3.992c.13.168.206.38.206.608v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6c0-.229.077-.44.206-.608L5.2 1.4ZM4 7v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7H4Zm15-2H5l1.5-2h11L19 5ZM8 9a1 1 0 0 1 1 1 3 3 0 0 0 6 0 1 1 0 1 1 2 0 5 5 0 1 1-10 0 1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const ShoppingCart = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 0a1 1 0 1 0 0 2h3.18l.832 4.155c.004.029.01.057.017.084l1.67 8.347A3 3 0 0 0 9.69 17h9.702a3 3 0 0 0 2.99-2.415l1.601-8.398A1 1 0 0 0 23 5H6.82L5.98.804A1 1 0 0 0 5 0H1Zm7.66 14.195L7.22 7h14.571l-1.372 7.198a1 1 0 0 1-1 .802H9.66a1 1 0 0 1-1-.805ZM7 21a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm11 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Shuffle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15 3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414L4.707 20.707a1 1 0 1 1-1.414-1.414L18.586 4H16a1 1 0 0 1-1-1Zm6 12a1 1 0 0 0-1 1v2.586l-4.293-4.293a1 1 0 0 0-1.414 1.414L18.586 20H16a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM4.707 3.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414-1.414l-5-5Z"
    })]
  }));
};

const Sidebar = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5 22a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5ZM4 5a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1V5Zm6 15V4h9a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Slash = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM6.382 4.968a9 9 0 0 1 12.65 12.65L6.382 4.968ZM4.968 6.382a9 9 0 0 0 12.65 12.65L4.968 6.382Z",
      clipRule: "evenodd"
    })]
  }));
};

const SleepTimer = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.377 3.378a1.5 1.5 0 0 0-1.57-.35A9.5 9.5 0 1 0 20.97 15.194a1.5 1.5 0 0 0-1.92-1.921 6.5 6.5 0 0 1-8.324-8.324 1.5 1.5 0 0 0-.35-1.57Zm-2.926 2.65a7.5 7.5 0 0 1 1.088-.7 8.498 8.498 0 0 0 10.133 10.133 7.504 7.504 0 0 1-8.266 3.821A7.5 7.5 0 0 1 7.451 6.028Zm8.111-3.278a.813.813 0 0 0 0 1.625h2.734l-3.35 3.909a.813.813 0 0 0 .617 1.341h4.5a.813.813 0 0 0 0-1.625h-2.734l3.35-3.909a.812.812 0 0 0-.616-1.341h-4.5Z",
      clipRule: "evenodd"
    })]
  }));
};

const SleepTimerActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15.563 2.75a.813.813 0 0 0 0 1.625h2.733l-3.35 3.909a.813.813 0 0 0 .617 1.341h4.5a.813.813 0 0 0 0-1.625h-2.734l3.35-3.909a.812.812 0 0 0-.616-1.341h-4.5ZM9.787 4.61a.5.5 0 0 0-.64-.641A8.5 8.5 0 1 0 20.03 14.854a.5.5 0 0 0-.64-.64 7.5 7.5 0 0 1-9.604-9.605Z"
    })]
  }));
};

const Sliders = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M21 3a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0V3ZM8 8a1 1 0 0 1 1-1h2V3a1 1 0 1 1 2 0v4h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 4a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0v-9ZM0 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5v6a1 1 0 1 1-2 0v-6H1a1 1 0 0 1-1-1Zm16 2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-2v4a1 1 0 1 1-2 0v-4h-2a1 1 0 0 1-1-1ZM5 3a1 1 0 0 0-2 0v7a1 1 0 1 0 2 0V3Z"
    })]
  }));
};

const Smartphone = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H7ZM6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4Zm6 13a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
      clipRule: "evenodd"
    })]
  }));
};

const Smile = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm4.4 1.2a1 1 0 0 1 1.397.196l.005.006.033.041a4.945 4.945 0 0 0 .815.748c.578.42 1.376.81 2.35.81.975 0 1.772-.39 2.35-.81a4.945 4.945 0 0 0 .815-.748l.034-.041.004-.006A1 1 0 0 1 16.8 14.6l-.001.001-.001.002-.003.004-.007.009-.021.027-.07.086c-.059.07-.142.164-.248.276a6.951 6.951 0 0 1-.923.804c-.798.58-2 1.191-3.526 1.191-1.525 0-2.728-.61-3.526-1.191a6.949 6.949 0 0 1-1.17-1.08 3.884 3.884 0 0 1-.07-.086l-.022-.027-.007-.01-.003-.003V14.6H7.2a1 1 0 0 1 .2-1.4ZM14 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1ZM9 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Songlist = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 5a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm15 0a1 1 0 0 0-1 1v9.17A3 3 0 1 0 19 18V7h2a1 1 0 1 0 0-2h-3ZM2 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H3Z"
    })]
  }));
};

const Speaker = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7 14a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-6a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12ZM3 4a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Square = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z",
      clipRule: "evenodd"
    })]
  }));
};

const Star = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1a1 1 0 0 1 .897.557l2.857 5.79 6.39.934a1 1 0 0 1 .554 1.705l-4.623 4.503 1.09 6.362a1 1 0 0 1-1.45 1.054L12 18.9l-5.715 3.005a1 1 0 0 1-1.45-1.054l1.09-6.362-4.623-4.503a1 1 0 0 1 .553-1.705l6.39-.935 2.858-5.789A1 1 0 0 1 12 1Zm0 3.26L9.807 8.702a1 1 0 0 1-.752.546l-4.907.718 3.55 3.457a1 1 0 0 1 .288.885l-.838 4.883 4.387-2.307a1 1 0 0 1 .93 0l4.387 2.307-.838-4.883a1 1 0 0 1 .288-.885l3.55-3.457-4.907-.718a1 1 0 0 1-.752-.546L12 4.259Z",
      clipRule: "evenodd"
    })]
  }));
};

const StarFilled = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 1a1 1 0 0 1 .897.557l2.857 5.79 6.39.934a1 1 0 0 1 .554 1.705l-4.623 4.503 1.09 6.362a1 1 0 0 1-1.45 1.054L12 18.9l-5.715 3.005a1 1 0 0 1-1.45-1.054l1.09-6.362-4.623-4.503a1 1 0 0 1 .553-1.705l6.39-.935 2.858-5.789A1 1 0 0 1 12 1Z"
    })]
  }));
};

const StarHalf = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.897 1.557a1 1 0 0 0-1.794 0l-2.857 5.79-6.39.934a1 1 0 0 0-.554 1.705l4.624 4.503-1.092 6.362a1 1 0 0 0 1.451 1.054L12 18.9l5.715 3.005a1 1 0 0 0 1.45-1.054l-1.09-6.362 4.623-4.503a1 1 0 0 0-.553-1.705l-6.39-.935-2.858-5.789Zm1.445 7.146-2.194-4.444V16.5s.175.232.466.385L17 19.192l-.837-4.883a1 1 0 0 1 .288-.885L20 9.967l-4.906-.717a1 1 0 0 1-.752-.547Z",
      clipRule: "evenodd"
    })]
  }));
};

const Stop = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M4.5 5.25a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-.75.75h-14a.75.75 0 0 1-.75-.75v-14Z",
      clipRule: "evenodd"
    })]
  }));
};

const SubtitlesMultiaudio = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.833 4.011C2.383 3.383 3.158 3 4 3h16c.842 0 1.618.383 2.167 1.011A3.46 3.46 0 0 1 23 6.286v11.428a3.46 3.46 0 0 1-.833 2.275C21.617 20.617 20.842 21 20 21h-5.15l-2.225 1.78a1 1 0 0 1-1.25 0L9.15 21H4c-.842 0-1.618-.383-2.167-1.011A3.46 3.46 0 0 1 1 17.714V6.286c0-.832.288-1.652.833-2.275ZM4 5c-.219 0-.46.098-.662.328A1.463 1.463 0 0 0 3 6.286v11.428c0 .381.134.724.338.958.201.23.443.328.662.328h5.5a1 1 0 0 1 .625.22L12 20.72l1.875-1.5A1 1 0 0 1 14.5 19H20c.219 0 .46-.098.662-.328.204-.234.338-.577.338-.958V6.286c0-.381-.134-.724-.338-.958C20.46 5.098 20.219 5 20 5H4Zm0 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm12 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM5 16a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2H5Zm5-3a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Sun = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 12a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm1-7a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V1Zm7.487 3.927a1 1 0 0 0-1.414-1.414l-1.42 1.42a1 1 0 0 0 1.414 1.414l1.42-1.42ZM1 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H1Zm19 1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM6.347 19.067a1 1 0 1 0-1.414-1.414l-1.42 1.42a1 1 0 1 0 1.414 1.414l1.42-1.42Zm11.306-1.414a1 1 0 0 1 1.414 0l1.42 1.42a1 1 0 0 1-1.414 1.414l-1.42-1.42a1 1 0 0 1 0-1.414ZM12 20a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1ZM3.513 3.513a1 1 0 0 1 1.414 0l1.42 1.42a1 1 0 0 1-1.414 1.414l-1.42-1.42a1 1 0 0 1 0-1.414Z",
      clipRule: "evenodd"
    })]
  }));
};

const Sunrise = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12.707 1.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 4.414v4.808c0 .43.448.778 1 .778s1-.348 1-.778V4.414l2.293 2.293a1 1 0 1 0 1.414-1.414l-4-4Zm7.78 8.22a1 1 0 0 1 0 1.414l-1.42 1.42a1 1 0 0 1-1.414-1.414l1.42-1.42a1 1 0 0 1 1.414 0ZM12 12a6 6 0 0 0-6 6 1 1 0 1 0 2 0 4 4 0 1 1 8 0 1 1 0 1 0 2 0 6 6 0 0 0-6-6Zm9 5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM1 21a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H1Zm-1-3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm4.927-8.487a1 1 0 0 0-1.414 1.414l1.42 1.42a1 1 0 0 0 1.414-1.414l-1.42-1.42Z"
    })]
  }));
};

const Sunset = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M12 1c.552 0 1 .348 1 .778v4.808l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L11 6.586V1.778c0-.43.448-.778 1-.778Zm8.487 8.513a1 1 0 0 1 0 1.414l-1.42 1.42a1 1 0 0 1-1.414-1.414l1.42-1.42a1 1 0 0 1 1.414 0ZM12 12a6 6 0 0 0-6 6 1 1 0 1 0 2 0 4 4 0 1 1 8 0 1 1 0 1 0 2 0 6 6 0 0 0-6-6Zm9 5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM1 21a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H1Zm-1-3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm4.927-8.487a1 1 0 0 0-1.414 1.414l1.42 1.42a1 1 0 0 0 1.414-1.414l-1.42-1.42Z"
    })]
  }));
};

const Tablet = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H6ZM5 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm7 13a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
      clipRule: "evenodd"
    })]
  }));
};

const Tag = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2 1a1 1 0 0 0-1 1v10a1 1 0 0 0 .293.707l8.59 8.58a2.999 2.999 0 0 0 4.245 0l7.17-7.17-.708-.707.71.705a3 3 0 0 0 0-4.23l-8.593-8.592A1 1 0 0 0 12 1H2Zm17.882 11.704-.001.001-7.168 7.168a1 1 0 0 1-1.415 0h-.001L3 11.584V3h8.586l8.295 8.295a1 1 0 0 1 0 1.41ZM7 6a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H7Z",
      clipRule: "evenodd"
    })]
  }));
};

const Target = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-6 0a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
      clipRule: "evenodd"
    })]
  }));
};

const Terminal = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M4.707 4.293a1 1 0 0 0-1.414 1.414L8.586 11l-5.293 5.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6ZM12 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
    })]
  }));
};

const Thermometer = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 25",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9.025 1.025A3.5 3.5 0 0 1 15 3.5v10.759a5.5 5.5 0 1 1-7 0V3.5a3.5 3.5 0 0 1 1.025-2.475ZM11.5 2A1.5 1.5 0 0 0 10 3.5v11.26a1 1 0 0 1-.444.832 3.5 3.5 0 1 0 3.888 0A1 1 0 0 1 13 14.76V3.5A1.5 1.5 0 0 0 11.5 2Z",
      clipRule: "evenodd"
    })]
  }));
};

const ThumbsDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20.564 3.316A1.31 1.31 0 0 0 19.688 3H18v9h1.688A1.31 1.31 0 0 0 21 10.923V4.077a1.31 1.31 0 0 0-.436-.761ZM16 12.788l-3.608 8.117A2 2 0 0 1 11 19v-4a1 1 0 0 0-1-1H4.329a1.001 1.001 0 0 1-1-1.15l1.38-9a1 1 0 0 1 1-.85H16v9.788ZM19.662 1a3.31 3.31 0 0 1 3.329 2.866c.006.044.009.09.009.134v7c0 .045-.003.09-.009.134A3.31 3.31 0 0 1 19.662 14H17.65l-3.736 8.406A1 1 0 0 1 13 23a4 4 0 0 1-4-4v-3H4.345a3 3 0 0 1-2.994-3.45l1.38-9A3.002 3.002 0 0 1 5.725 1h13.937Z",
      clipRule: "evenodd"
    })]
  }));
};

const ThumbsDownActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "m3.395 3.7-1.369 9a2.02 2.02 0 0 0 .353 1.5 1.985 1.985 0 0 0 1.304.8h5.945v4c0 .796.313 1.559.87 2.121A2.959 2.959 0 0 0 12.6 22l3.945-9V2H5.385a1.97 1.97 0 0 0-1.31.473 2.004 2.004 0 0 0-.68 1.227ZM18.364 2v10.91h1.85c.476-.006.93-.216 1.264-.588.334-.37.522-.872.522-1.395V3.982c0-.523-.188-1.024-.522-1.395A1.726 1.726 0 0 0 20.215 2h-1.851Z"
    })]
  }));
};

const ThumbsUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.086 1.594A1 1 0 0 1 11 1a4 4 0 0 1 4 4v3h4.655a3 3 0 0 1 2.994 3.45l-1.38 9A3.002 3.002 0 0 1 18.275 23H4a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h2.35l3.736-8.406ZM8 11.212l3.608-8.117A2 2 0 0 1 13 5v4a1 1 0 0 0 1 1h5.671a1 1 0 0 1 1 1.15l-1.38 9a1 1 0 0 1-1 .85H8v-9.788ZM6 21v-9H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2Z",
      clipRule: "evenodd"
    })]
  }));
};

const ThumbsUpActive = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "m20.605 20.3 1.37-9a2.022 2.022 0 0 0-.354-1.5 1.987 1.987 0 0 0-1.304-.8h-5.945V5c0-.796-.313-1.559-.87-2.121A2.959 2.959 0 0 0 11.4 2l-3.945 9v11h11.16c.479.007.945-.16 1.31-.473.367-.313.608-.749.68-1.227ZM5.636 22V11.09h-1.85c-.476.006-.93.216-1.264.588A2.088 2.088 0 0 0 2 13.073v6.945c0 .523.188 1.024.522 1.395s.788.582 1.263.587h1.851Z"
    })]
  }));
};

const Time = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm10-6a1 1 0 1 0-2 0v6a1 1 0 0 0 .553.894l4 2a1 1 0 1 0 .894-1.788L13 11.382V6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Tool = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.558 3.028a5 5 0 0 0-5.117 7.03 1 1 0 0 1-.204 1.12l-6.91 6.91a1.121 1.121 0 0 0 1.586 1.585l6.91-6.91a1 1 0 0 1 1.12-.204 5 5 0 0 0 7.029-5.117L18.4 10.014a2 2 0 0 1-2.8 0l-.007-.007L13.986 8.4a2 2 0 0 1 0-2.8l.007-.007 2.565-2.565ZM14.742 1.11a7 7 0 0 1 4.14.509 1 1 0 0 1 .295 1.618L15.414 7 17 8.586l3.763-3.763a1 1 0 0 1 1.618.295 7 7 0 0 1-8.606 9.521l-6.448 6.448a3.122 3.122 0 0 1-4.414-4.414l6.448-6.448a7 7 0 0 1 5.38-9.115Z",
      clipRule: "evenodd"
    })]
  }));
};

const Trash = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7 5V4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h4a1 1 0 1 1 0 2h-1v13a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7H3a1 1 0 0 1 0-2h4Zm2.293-1.707A1 1 0 0 1 10 3h4a1 1 0 0 1 1 1v1H9V4a1 1 0 0 1 .293-.707ZM6 7v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7H6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Trash2 = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7 5V4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h4a1 1 0 1 1 0 2h-1v13a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7H3a1 1 0 0 1 0-2h4Zm2.293-1.707A1 1 0 0 1 10 3h4a1 1 0 0 1 1 1v1H9V4a1 1 0 0 1 .293-.707ZM6 7v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7H6Zm9 4v6a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0Zm-4 0a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z",
      clipRule: "evenodd"
    })]
  }));
};

const Trello = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V7Zm2 1v3h1V8h-1ZM7 6a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm1 9V8h1v7H8ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z",
      clipRule: "evenodd"
    })]
  }));
};

const TrendingDown = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M1.707 5.293A1 1 0 0 0 .293 6.707l7.5 7.5a1 1 0 0 0 1.414 0L13.5 9.914 20.586 17H17a1 1 0 1 0 0 2h6.003a.996.996 0 0 0 .996-.952L24 18v-6a1 1 0 1 0-2 0v3.586l-7.793-7.793a1 1 0 0 0-1.414 0L8.5 12.086 1.707 5.293Z"
    })]
  }));
};

const TrendingUp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M17 5a1 1 0 1 0 0 2h3.586L13.5 14.086 9.207 9.793a1 1 0 0 0-1.414 0l-7.5 7.5a1 1 0 1 0 1.414 1.414L8.5 11.914l4.293 4.293a1 1 0 0 0 1.414 0L22 8.414V12a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1h-6Z"
    })]
  }));
};

const Triangle = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.528 2.283a3 3 0 0 1 4.037 1.058l.003.005 8.47 14.14.008.014a2.999 2.999 0 0 1-2.565 4.5H3.519a3.001 3.001 0 0 1-2.565-4.5l.008-.014 8.47-14.14.858.514-.855-.519a3 3 0 0 1 1.093-1.058Zm.618 2.094L2.683 18.506A1 1 0 0 0 3.536 20h16.928a1 1 0 0 0 .853-1.494L12.855 4.379l-.001-.002a1 1 0 0 0-1.708 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Truck = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1 2a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h1.337a3.5 3.5 0 1 0 6.326 0h6.674a3.5 3.5 0 1 0 6.326 0H23a1 1 0 0 0 1-1v-5a1 1 0 0 0-.293-.707l-3-3A1 1 0 0 0 20 7h-3V3a1 1 0 0 0-1-1H1Zm16 7v6h5v-3.586L19.586 9H17Zm-2-5H2v11h13V4ZM5.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM17 18.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Tv = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.707 1.293a1 1 0 0 0-1.414 1.414L9.586 6H4a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.586l3.293-3.293a1 1 0 0 0-1.414-1.414L12 5.586 7.707 1.293ZM3 9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Twitch = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2 2a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-.293.707l-4 4A1 1 0 0 1 17 19h-4.586l-3.707 3.707A1 1 0 0 1 7 22v-3H3a1 1 0 0 1-1-1V2Zm2 1v14h4a1 1 0 0 1 1 1v1.586l2.293-2.293A1 1 0 0 1 12 17h4.586L20 13.586V3H4Zm7 3a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm5 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const Twitter = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M23.154 5.13a9.443 9.443 0 0 1-2.617.718 4.516 4.516 0 0 0 1.998-2.51 9.076 9.076 0 0 1-2.88 1.1 4.54 4.54 0 0 0-7.856 3.106c0 .359.03.705.105 1.035-3.776-.185-7.117-1.994-9.362-4.751a4.573 4.573 0 0 0-.621 2.296c0 1.573.81 2.967 2.017 3.774a4.485 4.485 0 0 1-2.052-.56v.05a4.563 4.563 0 0 0 3.639 4.463c-.37.101-.773.15-1.19.15a4.01 4.01 0 0 1-.86-.078c.588 1.799 2.258 3.121 4.243 3.164a9.126 9.126 0 0 1-5.631 1.937c-.263 0-.38.366-.147.489A12.81 12.81 0 0 0 7.967 21c8.358 0 12.927-6.923 12.927-12.924 0-.2-.007-.395-.016-.587a9.06 9.06 0 0 0 2.276-2.358Z"
    })]
  }));
};

const Type = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V5h-6v14h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V5H5v2a1 1 0 0 1-2 0V4Z"
    })]
  }));
};

const Umbrella = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3.894 4.134a12.05 12.05 0 0 1 20.101 7.771A1 1 0 0 1 23 13H13v6a2 2 0 0 0 4 0 1 1 0 1 1 2 0 4 4 0 1 1-8 0v-6H1a1 1 0 0 1-.995-1.095 12.05 12.05 0 0 1 3.89-7.771ZM21.84 11a10.05 10.05 0 0 0-19.68 0h19.68Z",
      clipRule: "evenodd"
    })]
  }));
};

const Underline = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M7 3a1 1 0 0 0-2 0v7a7 7 0 1 0 14 0V3a1 1 0 1 0-2 0v7a5 5 0 1 1-10 0V3ZM4 20a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z"
    })]
  }));
};

const Unlock = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M15.559 2.164a6 6 0 0 1 2.321 3.637 1 1 0 1 1-1.96.398 4 4 0 0 0-7.914.572L8 7l-.001 3H19a3 3 0 0 1 2.995 2.824L22 13v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h.999L6 7a6 6 0 0 1 9.559-4.836ZM19 12H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1Z"
    })]
  }));
};

const Upload = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M11.293 2.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L13 5.414V15a1 1 0 1 1-2 0V5.414L7.707 8.707a1 1 0 0 1-1.414-1.414l5-5ZM3 14a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1Z"
    })]
  }));
};

const UploadCloud = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 25 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M8.669 2.009A9 9 0 0 1 17.484 8h.521a6.002 6.002 0 0 1 5.497 8.398 6 6 0 0 1-2.628 2.87 1 1 0 0 1-.957-1.756A4 4 0 0 0 18.005 10h-1.26a1 1 0 0 1-.968-.75 7 7 0 1 0-12.022 6.388 1 1 0 1 1-1.499 1.324A9 9 0 0 1 8.669 2.01Zm4.043 9.284a1 1 0 0 0-1.414 0l-4 4a1 1 0 1 0 1.414 1.414l2.293-2.293V21a1 1 0 1 0 2 0v-6.586l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4Z"
    })]
  }));
};

const User = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM9 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-1 7a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2a1 1 0 1 0 2 0v-2a5 5 0 0 0-5-5H8Z",
      clipRule: "evenodd"
    })]
  }));
};

const UserCheck = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8.5 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm18.207 1.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L19 11.586l3.293-3.293a1 1 0 0 1 1.414 0ZM1.464 15.464A5 5 0 0 1 5 14h7a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 1.464-3.536Z",
      clipRule: "evenodd"
    })]
  }));
};

const UserMinus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8.5 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM16 11a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1ZM1.464 15.464A5 5 0 0 1 5 14h7a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 1.464-3.536Z",
      clipRule: "evenodd"
    })]
  }));
};

const UserPlus = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8.5 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM21 8a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V8ZM5 14a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v2a1 1 0 1 0 2 0v-2a5 5 0 0 0-5-5H5Z",
      clipRule: "evenodd"
    })]
  }));
};

const Users = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9 2a5 5 0 1 0 0 10A5 5 0 0 0 9 2ZM6 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm9.031-4.118a1 1 0 0 1 1.217-.72 5 5 0 0 1 0 9.687 1 1 0 0 1-.496-1.938 3 3 0 0 0 0-5.812 1 1 0 0 1-.72-1.217ZM5 14a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2a1 1 0 1 0 2 0v-2a5 5 0 0 0-5-5H5Zm15.25.162a1 1 0 1 0-.5 1.936A3 3 0 0 1 22 19.001V21a1 1 0 1 0 2 0v-2a5 5 0 0 0-3.75-4.838Z",
      clipRule: "evenodd"
    })]
  }));
};

const UserX = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M8.5 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm13.207.293a1 1 0 1 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 0 0 1.414 1.414l1.793-1.793 1.793 1.793a1 1 0 0 0 1.414-1.414L21.914 10.5l1.793-1.793a1 1 0 0 0-1.414-1.414L20.5 9.086l-1.793-1.793ZM5 14a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v2a1 1 0 1 0 2 0v-2a5 5 0 0 0-5-5H5Z",
      clipRule: "evenodd"
    })]
  }));
};

const Video = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M17 10.057V7a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-3.057l5.419 3.87A1 1 0 0 0 24 17V7a1 1 0 0 0-1.581-.814L17 10.056ZM2 7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7Zm20 8.057L17.72 12 22 8.943v6.114Z",
      clipRule: "evenodd"
    })]
  }));
};

const VideoOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.707.293A1 1 0 0 0 .293 1.707L2.61 4.025A3 3 0 0 0 0 7v10a3 3 0 0 0 3 3h11a3 3 0 0 0 2.76-1.825l5.533 5.532a1 1 0 0 0 1.414-1.414l-22-22ZM15 16.414 4.586 6H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-.586ZM10.66 6H14a1 1 0 0 1 1 1v3.34a1 1 0 0 0 .293.707l1 1a1 1 0 0 0 1.293.103L22 8.958V17a1 1 0 1 0 2 0V7a1 1 0 0 0-1.586-.81l-5.31 3.84L17 9.926V7a3 3 0 0 0-3-3h-3.34a1 1 0 1 0 0 2Z",
      clipRule: "evenodd"
    })]
  }));
};

const Voicemail = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9.743 15A5.5 5.5 0 1 0 5.5 17h13a5.5 5.5 0 1 0-4.243-2H9.743ZM2 11.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM18.5 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
      clipRule: "evenodd"
    })]
  }));
};

const Volume = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.433 4.099A1 1 0 0 1 12 5v14a1 1 0 0 1-1.625.78L5.65 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.65l4.725-3.78a1 1 0 0 1 1.058-.121ZM10 7.08l-3.375 2.7A1 1 0 0 1 6 10H3v4h3a1 1 0 0 1 .625.22L10 16.92V7.08Z",
      clipRule: "evenodd"
    })]
  }));
};

const VolumeHigh = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 5a1 1 0 0 0-1.625-.78L5.65 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.725 3.78A1 1 0 0 0 12 19V5ZM6.625 9.78 10 7.08v9.84l-3.375-2.7A1 1 0 0 0 6 14H3v-4h3a1 1 0 0 0 .625-.22Zm13.152-5.557a1 1 0 1 0-1.414 1.414 9 9 0 0 1 0 12.726 1 1 0 1 0 1.414 1.414 11 11 0 0 0 0-15.554Zm-3.53 3.53a1 1 0 1 0-1.414 1.414 4 4 0 0 1 0 5.656 1 1 0 1 0 1.414 1.414 6 6 0 0 0 0-8.484Z",
      clipRule: "evenodd"
    })]
  }));
};

const VolumeLow = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 5a1 1 0 0 0-1.625-.78L5.65 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.725 3.78A1 1 0 0 0 12 19V5ZM6.625 9.78 10 7.08v9.84l-3.375-2.7A1 1 0 0 0 6 14H3v-4h3a1 1 0 0 0 .625-.22Zm9.622-2.027a1 1 0 1 0-1.414 1.414 4 4 0 0 1 0 5.656 1 1 0 1 0 1.414 1.414 6 6 0 0 0 0-8.484Z",
      clipRule: "evenodd"
    })]
  }));
};

const VolumeOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12 5a1 1 0 0 0-1.625-.78L5.65 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.725 3.78A1 1 0 0 0 12 19V5ZM6.625 9.78 10 7.08v9.84l-3.375-2.7A1 1 0 0 0 6 14H3v-4h3a1 1 0 0 0 .625-.22Zm17.082-1.487a1 1 0 0 1 0 1.414L21.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L20 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L18.586 12l-2.293-2.293a1 1 0 0 1 1.414-1.414L20 10.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    })]
  }));
};

const Watch = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M14.16 0a2.983 2.983 0 0 1 2.022.781c.553.505.898 1.2.965 1.948l-.002-.001.002.002.312 3.422A7.978 7.978 0 0 1 20 12a7.978 7.978 0 0 1-2.541 5.848l-.312 3.422a3.005 3.005 0 0 1-.96 1.944 2.983 2.983 0 0 1-2.014.786H9.84a2.983 2.983 0 0 1-2.022-.781 3.004 3.004 0 0 1-.965-1.948l.001.001-.001-.002-.312-3.422A7.978 7.978 0 0 1 4 12a7.98 7.98 0 0 1 2.541-5.848l.312-3.422c.067-.745.41-1.439.96-1.944A2.983 2.983 0 0 1 9.826 0h4.333Zm1.003 2.91.165 1.813A7.97 7.97 0 0 0 12 4a7.97 7.97 0 0 0-3.328.723l.165-1.813A1.001 1.001 0 0 1 9.83 2h4.337a.994.994 0 0 1 .997.91ZM6 12a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm9.328 7.277A7.97 7.97 0 0 1 12 20a7.97 7.97 0 0 1-3.328-.723l.165 1.813a1.001 1.001 0 0 0 .997.91h4.338a.995.995 0 0 0 .99-.91l.166-1.813ZM13 9a1 1 0 1 0-2 0v3a1 1 0 0 0 .293.707l1.5 1.5a1 1 0 0 0 1.414-1.414L13 11.586V9Z",
      clipRule: "evenodd"
    })]
  }));
};

const Whatsapp = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M19.194 4.806A9.518 9.518 0 0 0 12.419 2a9.518 9.518 0 0 0-6.774 2.806 9.518 9.518 0 0 0-2.806 6.775c0 1.62.41 3.214 1.19 4.625L2 22l5.794-2.028a9.576 9.576 0 0 0 4.625 1.19 9.518 9.518 0 0 0 6.775-2.807A9.518 9.518 0 0 0 22 11.581a9.52 9.52 0 0 0-2.806-6.775ZM17.156 15.14l-1.106 1.106c-.917.916-3.516-.198-5.807-2.489-2.29-2.29-3.405-4.89-2.489-5.807L8.86 6.844c.23-.229.6-.229.83 0l1.382 1.383c.23.229.23.6 0 .83l-.83.829a8.138 8.138 0 0 0 3.872 3.871l.83-.83a.587.587 0 0 1 .83 0l1.382 1.383c.229.23.229.6 0 .83Z"
    })]
  }));
};

const Wifi = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M2.081 9.75a15 15 0 0 1 19.838 0 1 1 0 1 0 1.322-1.5 17 17 0 0 0-22.482 0 1 1 0 0 0 1.322 1.5Zm9.959 1.252a10 10 0 0 0-6.4 2.316 1 1 0 1 1-1.28-1.536 12 12 0 0 1 15.36 0 1 1 0 1 1-1.28 1.536 10 10 0 0 0-6.4-2.316Zm-2.93 5.923a5 5 0 0 1 5.79 0 1 1 0 0 0 1.16-1.63 7 7 0 0 0-8.11 0 1 1 0 1 0 1.16 1.63ZM12 19a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
    })]
  }));
};

const WifiOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      d: "M.293.293a1 1 0 0 1 1.414 0l5.107 5.106.027.028 3.947 3.947c.063.049.12.106.17.17l12.75 12.749a1 1 0 0 1-1.415 1.414l-6.617-6.617a.997.997 0 0 1-.775-.165 5 5 0 0 0-5.792 0 1 1 0 0 1-1.158-1.63 7 7 0 0 1 4.663-1.267l-2.782-2.782a9.94 9.94 0 0 0-4.19 2.071 1 1 0 1 1-1.283-1.534A11.94 11.94 0 0 1 8.21 9.626L5.888 7.302a14.91 14.91 0 0 0-3.806 2.447A1 1 0 0 1 .758 8.251 16.91 16.91 0 0 1 4.386 5.8L.293 1.706a1 1 0 0 1 0-1.414ZM11 20a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4.821-9.379a1 1 0 0 1 1.338-.46c.893.437 1.73.983 2.488 1.627a1 1 0 1 1-1.294 1.524 9.942 9.942 0 0 0-2.072-1.353 1 1 0 0 1-.46-1.338Zm-5.03-4.574A15 15 0 0 1 21.918 9.75a1 1 0 0 0 1.323-1.5A17 17 0 0 0 10.63 4.053a1 1 0 0 0 .16 1.994Z"
    })]
  }));
};

const Wind = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.202 5.019a1 1 0 0 0-.903.276 1 1 0 1 1-1.418-1.41A3 3 0 1 1 10.998 9h-.002L11 8v1H2a1 1 0 1 1 0-2h9.004a1 1 0 0 0 .198-1.981Zm8.587 3.01a1.5 1.5 0 0 0-1.353.409 1 1 0 1 1-1.412-1.416A3.5 3.5 0 1 1 19.502 13H2a1 1 0 1 1 0-2h17.499a1.5 1.5 0 0 0 .29-2.971ZM13.998 15a3 3 0 1 1-2.117 5.115 1 1 0 1 1 1.418-1.41A1 1 0 1 0 14.004 17H2a1 1 0 1 1 0-2h11.998Z",
      clipRule: "evenodd"
    })]
  }));
};

const Youtube = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.08 3h-.16a96.464 96.464 0 0 0-1.033.007c-.676.007-1.596.022-2.572.05-.974.03-2.011.074-2.918.14-.88.064-1.722.154-2.255.297l-.014.004A3.78 3.78 0 0 0 .476 6.283 30 30 0 0 0 0 11.749a30 30 0 0 0 .476 5.508.996.996 0 0 0 .022.097 3.78 3.78 0 0 0 2.638 2.61l.006.002c.533.143 1.375.233 2.255.297.907.066 1.944.11 2.918.14a138.66 138.66 0 0 0 3.605.057h.16a117.552 117.552 0 0 0 1.033-.007 138.67 138.67 0 0 0 2.572-.05 70.554 70.554 0 0 0 2.918-.14c.88-.064 1.722-.154 2.255-.297l.014-.004a3.78 3.78 0 0 0 2.652-2.785c.323-1.79.482-3.606.476-5.426a29.997 29.997 0 0 0-.476-5.509l-.014-.065a3.78 3.78 0 0 0-2.673-2.728c-.525-.129-1.36-.211-2.24-.27-.905-.06-1.941-.1-2.915-.126A151.086 151.086 0 0 0 12.08 3Zm-.155 2h.37a146.465 146.465 0 0 1 3.333.052c.961.026 1.968.065 2.836.123.879.058 1.541.132 1.881.212a1.78 1.78 0 0 1 1.218 1.247c.301 1.686.448 3.397.437 5.11v.01a27.999 27.999 0 0 1-.438 5.032 1.78 1.78 0 0 1-1.227 1.25c-.329.086-.989.168-1.877.233-.866.063-1.872.105-2.833.134a136.743 136.743 0 0 1-3.55.057h-.37a140.377 140.377 0 0 1-3.33-.057 68.467 68.467 0 0 1-2.833-.134c-.892-.066-1.553-.147-1.88-.234a1.78 1.78 0 0 1-1.227-1.186A28 28 0 0 1 2 11.756v-.01a28 28 0 0 1 .438-5.072 1.78 1.78 0 0 1 1.227-1.25c.33-.086.99-.168 1.877-.233a68.552 68.552 0 0 1 2.833-.134A136.039 136.039 0 0 1 11.925 5Zm-1.68 2.61a1 1 0 0 0-1.495.87v6.54a1 1 0 0 0 1.494.87l5.75-3.27a1 1 0 0 0 0-1.74l-5.75-3.27Z",
      clipRule: "evenodd"
    })]
  }));
};

const Zap = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.398 1.083a1 1 0 0 1 .594 1.041L13.132 9H21a1 1 0 0 1 .768 1.64l-10 12a1 1 0 0 1-1.76-.764l.86-6.876H3a1 1 0 0 1-.768-1.64l10-12a1 1 0 0 1 1.166-.277ZM5.135 13H12a1 1 0 0 1 .992 1.124l-.577 4.616 6.45-7.74H12a1 1 0 0 1-.992-1.124l.577-4.615L5.135 13Z",
      clipRule: "evenodd"
    })]
  }));
};

const ZapOff = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M1.707.293A1 1 0 0 0 .293 1.707l6.354 6.354-4.415 5.299A1 1 0 0 0 3 15h7.867l-.86 6.876a1 1 0 0 0 1.761.764l4.3-5.159 6.225 6.226a1 1 0 0 0 1.414-1.414L16.715 15.3a1.047 1.047 0 0 0-.014-.015L8.715 7.301a1.093 1.093 0 0 0-.014-.015L1.707.293Zm6.36 9.188L5.135 13h6.45L8.068 9.481Zm4.894 4.894-.546 4.365 2.232-2.679-1.686-1.686Zm.437-13.293a1 1 0 0 1 .595 1.041l-.59 4.75a1 1 0 0 1-1.985-.246l.17-1.366-.25.299a1 1 0 1 1-1.537-1.28l2.43-2.92a1 1 0 0 1 1.167-.278ZM15.66 9a1 1 0 1 0 0 2h3.202l-1.06 1.269a1 1 0 0 0 1.535 1.282l2.43-2.91A1 1 0 0 0 21 9h-5.34Z",
      clipRule: "evenodd"
    })]
  }));
};

const ZoomIn = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.618 18.032a9 9 0 1 1 1.414-1.414l3.675 3.675a1 1 0 0 1-1.414 1.414l-3.675-3.675ZM4 11a7 7 0 1 1 12.042 4.856 1.005 1.005 0 0 0-.186.186A7 7 0 0 1 4 11Zm7-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H8a1 1 0 1 1 0-2h2V8a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

const ZoomOut = _a => {
  var {
    title = '',
    titleId = '',
    width = '24px',
    height = '24px',
    color = 'currentColor'
  } = _a,
      props = __rest(_a, ["title", "titleId", "width", "height", "color"]);

  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsx("title", Object.assign({
      id: titleId
    }, {
      children: title
    })) : null, jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11 20a8.962 8.962 0 0 0 5.618-1.968l3.675 3.675a1 1 0 1 0 1.414-1.414l-3.675-3.675A9 9 0 1 0 11 20Zm0-16a7 7 0 1 0 4.857 12.041 1.009 1.009 0 0 1 .184-.184A7 7 0 0 0 11 4Zm-3 6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H8Z",
      clipRule: "evenodd"
    })]
  }));
};

export { Activity, Airplay, AirplayAudio, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowLeftCircle, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, AtSign, Audio, Award, BarChart, BarChart2, Battery, BatteryCharging, Bluetooth, Bold, Book, BookOpen, Bookmark, BookmarkActive, Box, Briefcase, Calendar, Camera, CameraOff, Cast, CastConnected, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, Circle, Clipboard, Clock, Close, ClosedCaption, Cloud, CloudDrizzle, CloudLightning, CloudRain, CloudSnow, Code, Codepen, Codesandbox, Coffee, Columns, Command, Compass, ConnectedDevices, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Crosshair, Database, Date, Delete, DeleteActive, Disc, DollarSign, Download, DownloadCloud, DragHandle, Droplet, Duration, Edit, Edit2, Edit3, Episodes, ExternalLink, Eye, EyeOff, Facebook, FastForward, FastRewind, Favorite, FavoriteActive, Feather, Feedback, Figma, File, FileMinus, FilePlus, FileText, Filter, Filter2, Flag, Folder, FolderMinus, FolderPlus, Forward10, Frown, Fullscreen, FullscreenExit, Game, Gift, GitBranch, GitCommit, GitPullRequest, Globe, Grid, HardDrive, Hash, Hd, Headphones, HelpCircle, HelpCircleActive, Hexagon, HighQuality, History, Home, HomeActive, Icon4k, Image, Inbox, Info, Instagram, Interactive, Italic, Key, Layers, Layout, LifeBuoy, Link, Link2, Linkedin, List, Loader, Location, Lock, LogIn, LogOut, Mail, Map, Meh, Menu, MessageCircle, MessageSquare, MessageSquareActive, Mic, MicOff, Minus, MinusCircle, MinusSquare, Monitor, Moon, MoreHorizontal, MoreVertical, MousePointer, Move, Music, Navigation, Navigation2, Next, Notification, NotificationActive, NotificationOff, NotificationOn, Octagon, Package, Paperclip, Pause, PenTool, Percent, Phone, PictureInPicture, PictureInPictureExit, PieChart, Play, Playlist, Plus, PlusCircle, PlusSquare, Pocket, Podcast, Power, Previous, Printer, PrivacyPolicy, PrivacyPolicyActive, Radio, RefreshCcw, RefreshCw, Repeat, Replay, Replay10, Reply, RotateCcw, RotateCw, Rss, Scissors, Search, Send, Server, Settings, Share, ShareAndroid, ShareIos, Shield, ShieldOff, ShoppingBag, ShoppingCart, Shuffle, Sidebar, Slash, SleepTimer, SleepTimerActive, Sliders, Smartphone, Smile, Songlist, Speaker, Square, Star, StarFilled, StarHalf, Stop, SubtitlesMultiaudio, Sun, Sunrise, Sunset, Tablet, Tag, Target, Terminal, Thermometer, ThumbsDown, ThumbsDownActive, ThumbsUp, ThumbsUpActive, Time, Tool, Trash, Trash2, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Twitch, Twitter, Type, Umbrella, Underline, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Users, Video, VideoOff, Voicemail, Volume, VolumeHigh, VolumeLow, VolumeOff, Watch, Whatsapp, Wifi, WifiOff, Wind, Youtube, Zap, ZapOff, ZoomIn, ZoomOut };
